import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Container, Typography, Paper, Box, Button, List, ListItem, ListItemText, ListItemIcon,
  Dialog, DialogTitle, DialogContent, TextField, DialogActions, Table, 
  TableBody, TableCell, TableHead, TableRow, TableContainer, Tabs, Tab, Grid, Card, CardContent, CardActions,
  Select, MenuItem, FormControl, InputLabel, IconButton, LinearProgress, Checkbox,
  Accordion, AccordionSummary, AccordionDetails, Chip, Avatar, Divider, Tooltip, CircularProgress, Autocomplete, Grow, InputAdornment
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DownloadIcon from '@mui/icons-material/Download';
import QrCodeIcon from '@mui/icons-material/QrCode';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventIcon from '@mui/icons-material/Event';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import MapIcon from '@mui/icons-material/Map';
import PublicIcon from '@mui/icons-material/Public';
import BusinessIcon from '@mui/icons-material/Business';
import FolderIcon from '@mui/icons-material/Folder';
import FlagIcon from '@mui/icons-material/Flag';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DescriptionIcon from '@mui/icons-material/Description';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import InfoIcon from '@mui/icons-material/Info';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HistoryIcon from '@mui/icons-material/History';
import axios from 'axios';
import API_URL from '../config';
import Loading from '../components/Loading';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3, px: { xs: 1, sm: 2, md: 3 }, overflowX: 'hidden' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function ProjectDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  
  // Edit Mode State
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState({});

  // Lookup Data
  const [divisions, setDivisions] = useState([]);
  const [countries, setCountries] = useState([]);

  // Team State
  const [team, setTeam] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [openAssignDialog, setOpenAssignDialog] = useState(false);
  const [assignUser, setAssignUser] = useState('');
  const [assignRole, setAssignRole] = useState('Member');

  // Report State
  const [openReportDialog, setOpenReportDialog] = useState(false);
  const [newReportName, setNewReportName] = useState('');
  const [createReportLoading, setCreateReportLoading] = useState(false);
  const [editingReportId, setEditingReportId] = useState(null);
  const [editingReportName, setEditingReportName] = useState('');

  // Documents State
  const [documents, setDocuments] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);

  // Member Details State
  const [openMemberDialog, setOpenMemberDialog] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [memberHours, setMemberHours] = useState([]);

  // Milestones State
  const [milestones, setMilestones] = useState([]);
  const [openMilestoneDialog, setOpenMilestoneDialog] = useState(false);
  const [newMilestoneName, setNewMilestoneName] = useState('');
  const [newMilestoneDate, setNewMilestoneDate] = useState('');
  const [newMilestoneDesc, setNewMilestoneDesc] = useState('');
  const [assignLoading, setAssignLoading] = useState(false);
  const [editingMilestone, setEditingMilestone] = useState(null);
  const [openEditMilestoneDialog, setOpenEditMilestoneDialog] = useState(false);
  const [editMilestoneName, setEditMilestoneName] = useState('');
  const [editMilestoneDate, setEditMilestoneDate] = useState('');
  const [editMilestoneDesc, setEditMilestoneDesc] = useState('');

  // QR Dialog State
  const [qrDialog, setQrDialog] = useState({ open: false, url: '', title: '' });

  // References State
  const [openReferenceDialog, setOpenReferenceDialog] = useState(false);
  const [createReferenceLoading, setCreateReferenceLoading] = useState(false);
  const [newReference, setNewReference] = useState({ type: 'In', subject: '', recipient_to: '', address: '', description: '' });

  // SubReport Upload State
  const [uploadSubReportId, setUploadSubReportId] = useState(null);
  const [uploadingSubReportId, setUploadingSubReportId] = useState(null);
  const [addingRevisionId, setAddingRevisionId] = useState(null);
  const fileInputRef = React.useRef(null);

  // SubReport Edit State
  const [editSubDialog, setEditSubDialog] = useState({ open: false, sub: null, submittedAt: '' });
  const [savingSubEdit, setSavingSubEdit] = useState(false);

  // Link Edit State
  const [editingProjectLink, setEditingProjectLink] = useState(false);
  const [tempProjectLink, setTempProjectLink] = useState('');

  // Contracts State
  const [contracts, setContracts] = useState([]);
  const [openAddContract, setOpenAddContract] = useState(false);
  const [createContractLoading, setCreateContractLoading] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const [newContract, setNewContract] = useState({
    client_id: '',
    country_id: '',
    division_id: '',
    description: '',
    ddp: '',
    document_type: '',
    file: null
  });

  // AI Reports State
  const aiReportTypes = [
    { value: 'gpr', label: 'GPR Report', endpoint: 'generate_gpr' },
    { value: 'hcp', label: 'HCP Report', endpoint: 'generate_hcp' },
    { value: 'hcp_voltage', label: 'HCP Voltage Report', endpoint: 'generate_hcp_voltage' },
    { value: 'esr', label: 'ESR Report', endpoint: 'generate_esr' },
    { value: 'esr_cores', label: 'ESR Cores Report', endpoint: 'generate_esr_cores' },
    { value: 'upv', label: 'UPV Report', endpoint: 'generate_upv' },
    { value: 'upv_cores', label: 'UPV Cores Report', endpoint: 'generate_upv_cores' },
    { value: 'srh', label: 'SRH Report', endpoint: 'generate_srh' },
    { value: 'echo', label: 'Echo Report', endpoint: 'generate_echo' },
    { value: 'carbo', label: 'Carbo Report', endpoint: 'generate_carbo' },
    { value: 'ph', label: 'PH Report', endpoint: 'generate_ph' },
    { value: 'sulfate', label: 'Sulfate Report', endpoint: 'generate_sulfate' },
    { value: 'water', label: 'Water Report', endpoint: 'generate_water' },
    { value: 'rcpt', label: 'RCPT Report', endpoint: 'generate_rcpt' },
    { value: 'chloride', label: 'Chloride Report', endpoint: 'generate_chloride' },
    { value: 'gfr', label: 'GFR (Geo Report)', endpoint: 'generate_gfr' },
  ];
  const [selectedAiReport, setSelectedAiReport] = useState('');
  const [aiReportFiles, setAiReportFiles] = useState([]);
  const [generatingAiReport, setGeneratingAiReport] = useState(false);
  const [aiReportHistory, setAiReportHistory] = useState([]);
  const [loadingAiHistory, setLoadingAiHistory] = useState(false);
  const [openAiReportDialog, setOpenAiReportDialog] = useState(false);
  const aiFileInputRef = React.useRef(null);

  // Financial / Payments State
  const [payments, setPayments] = useState([]);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [editingPayment, setEditingPayment] = useState(null);
  const [paymentForm, setPaymentForm] = useState({
    amount: '',
    payment_date: '',
    payment_method: '',
    reference_number: '',
    status: 'Pending',
    notes: ''
  });
  const [savingPayment, setSavingPayment] = useState(false);

  // GFR-specific state
  const [gfrFiles, setGfrFiles] = useState({
    project_location_image: null,
    bore_hole_image: null,
    trial_pit_image: null,
    geological_map: null,
    gint_file: null,
    groundwater_file: null,
    falling_head_file: null,
    n60_file: null,
    pmt_file: null,
    soakaway_file: null,
    lab_file: null,
    packer_files: [],
  });
  const [gfrSiteDescription, setGfrSiteDescription] = useState('');
  const [gfrRegionalGeology, setGfrRegionalGeology] = useState('');
  const [gfrCountryOrigin, setGfrCountryOrigin] = useState('KSA');
  const [openGfrDialog, setOpenGfrDialog] = useState(false);
  const [generatingGfr, setGeneratingGfr] = useState(false);
  const gfrFileRefs = {
    project_location_image: React.useRef(null),
    bore_hole_image: React.useRef(null),
    trial_pit_image: React.useRef(null),
    geological_map: React.useRef(null),
    gint_file: React.useRef(null),
    groundwater_file: React.useRef(null),
    falling_head_file: React.useRef(null),
    n60_file: React.useRef(null),
    pmt_file: React.useRef(null),
    soakaway_file: React.useRef(null),
    lab_file: React.useRef(null),
    packer_files: React.useRef(null),
  };

  const handleGfrFileChange = (fieldName, e) => {
    const files = e.target.files;
    if (fieldName === 'packer_files') {
      setGfrFiles(prev => ({ ...prev, packer_files: Array.from(files) }));
    } else {
      setGfrFiles(prev => ({ ...prev, [fieldName]: files[0] || null }));
    }
  };

  const handleGenerateGfr = async () => {
    if (!gfrFiles.gint_file) { alert('Gint Sheet is required!'); return; }
    if (!gfrFiles.project_location_image) { alert('Project Location Image is required!'); return; }
    if (!gfrFiles.bore_hole_image) { alert('Bore Hole Image is required!'); return; }
    if (!gfrFiles.trial_pit_image) { alert('Trial Pit Image is required!'); return; }
    if (gfrCountryOrigin === 'KSA') {
      if (!gfrFiles.geological_map) { alert('Geological Map Image is required for KSA!'); return; }
      if (!gfrRegionalGeology.trim()) { alert('Regional Geology is required for KSA!'); return; }
    }
    if (!gfrSiteDescription.trim()) { alert('Site Description is required!'); return; }

    setGeneratingGfr(true);
    const formData = new FormData();
    formData.append('project_location_image', gfrFiles.project_location_image);
    formData.append('bore_hole_image', gfrFiles.bore_hole_image);
    formData.append('trial_pit_image', gfrFiles.trial_pit_image);
    formData.append('gint_file', gfrFiles.gint_file);
    if (gfrFiles.geological_map) formData.append('geological_map', gfrFiles.geological_map);
    if (gfrFiles.groundwater_file) formData.append('groundwater_file', gfrFiles.groundwater_file);
    if (gfrFiles.falling_head_file) formData.append('falling_head_file', gfrFiles.falling_head_file);
    if (gfrFiles.n60_file) formData.append('n60_file', gfrFiles.n60_file);
    if (gfrFiles.pmt_file) formData.append('pmt_file', gfrFiles.pmt_file);
    if (gfrFiles.soakaway_file) formData.append('soakaway_file', gfrFiles.soakaway_file);
    if (gfrFiles.lab_file) formData.append('lab_file', gfrFiles.lab_file);
    gfrFiles.packer_files.forEach(f => formData.append('packer_files', f));
    formData.append('site_description', gfrSiteDescription);
    if (gfrRegionalGeology.trim()) formData.append('regional_geology', gfrRegionalGeology);
    formData.append('country_origin', gfrCountryOrigin);
    formData.append('project_id', id);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user && user.id) formData.append('user_id', user.id);

    try {
      const response = await axios.post(`${API_URL}/ai-reports/generate_gfr`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'GFR_Report.docx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setOpenGfrDialog(false);
      resetGfrForm();
      fetchAiReportHistory();
    } catch (err) {
      console.error('Error generating GFR report:', err);
      let msg = 'Error generating GFR report.';
      if (err.response && err.response.data) {
        try { const text = await new Response(err.response.data).text(); msg = text || msg; } catch (e) {}
      }
      alert(msg);
    } finally {
      setGeneratingGfr(false);
    }
  };

  const resetGfrForm = () => {
    setGfrFiles({
      project_location_image: null, bore_hole_image: null, trial_pit_image: null,
      geological_map: null, gint_file: null, groundwater_file: null,
      falling_head_file: null, n60_file: null, pmt_file: null,
      soakaway_file: null, lab_file: null, packer_files: [],
    });
    setGfrSiteDescription('');
    setGfrRegionalGeology('');
    setGfrCountryOrigin('KSA');
  };

  const renderGfrFileDropzone = (fieldName, label, accept, required = false) => {
    const file = fieldName === 'packer_files' ? null : gfrFiles[fieldName];
    const files = fieldName === 'packer_files' ? gfrFiles.packer_files : null;
    return (
      <Box>
        <Typography variant="caption" sx={{ fontWeight: 700, color: '#475569', display: 'block', mb: 0.5 }}>
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </Typography>
        <Paper
          elevation={0}
          onClick={() => gfrFileRefs[fieldName].current && gfrFileRefs[fieldName].current.click()}
          sx={{
            p: 1.5, textAlign: 'center', bgcolor: '#f8fafc', borderRadius: 1.5,
            border: '1px dashed #cbd5e1', cursor: 'pointer',
            '&:hover': { borderColor: '#1976d2', bgcolor: '#eff6ff' }
          }}
        >
          {file ? (
            <Typography variant="caption" sx={{ color: '#1976d2', fontWeight: 600 }}>
              {file.name}
            </Typography>
          ) : files && files.length > 0 ? (
            <Typography variant="caption" sx={{ color: '#1976d2', fontWeight: 600 }}>
              {files.length} file(s) selected
            </Typography>
          ) : (
            <Typography variant="caption" color="#94a3b8">
              Click to select
            </Typography>
          )}
        </Paper>
        <input type="file" ref={gfrFileRefs[fieldName]} style={{ display: 'none' }}
          accept={accept} multiple={fieldName === 'packer_files'}
          onChange={(e) => handleGfrFileChange(fieldName, e)} />
      </Box>
    );
  };

  const fetchAiReportHistory = async () => {
    setLoadingAiHistory(true);
    try {
      const res = await axios.get(`${API_URL}/ai-reports/local-reports?project_id=${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (Array.isArray(res.data)) {
        setAiReportHistory(res.data);
      }
    } catch (err) {
      console.error('Error fetching AI report history:', err);
    } finally {
      setLoadingAiHistory(false);
    }
  };

  const handleAiFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setAiReportFiles(files);
    }
  };

  const handleGenerateAiReport = async () => {
    if (!selectedAiReport) {
      alert('Please select a report type.');
      return;
    }
    if (aiReportFiles.length === 0) {
      alert('Please select at least one file to upload.');
      return;
    }

    setGeneratingAiReport(true);
    const reportType = aiReportTypes.find(r => r.value === selectedAiReport);
    const formData = new FormData();
    aiReportFiles.forEach(file => {
      formData.append('excel_file', file);
    });
    formData.append('project_id', id);
    
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user && user.id) {
      formData.append('user_id', user.id);
    }

    try {
      const response = await axios.post(`${API_URL}/ai-reports/${reportType.endpoint}`, formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${reportType.label.replace(/\s+/g, '_')}_report.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setOpenAiReportDialog(false);
      setAiReportFiles([]);
      setSelectedAiReport('');
      if (aiFileInputRef.current) aiFileInputRef.current.value = '';
      fetchAiReportHistory();
    } catch (err) {
      console.error('Error generating AI report:', err);
      let msg = 'Error generating report.';
      if (err.response && err.response.data) {
        try {
          const text = await new Response(err.response.data).text();
          msg = text || msg;
        } catch (e) {}
      }
      alert(msg);
    } finally {
      setGeneratingAiReport(false);
    }
  };

  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('user_role') || '';
  const userPermissions = JSON.parse(localStorage.getItem('user_permissions') || '[]');
  const canViewContracts = userRole === 'Admin' || userPermissions.includes('Contracts');

  const fetchProject = async () => {
    try {
      const res = await axios.get(`${API_URL}/projects/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProject(res.data);
      setEditData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchTeam = async () => {
    try {
      const res = await axios.get(`${API_URL}/projects/${id}/team`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTeam(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAllUsers = async () => {
    try {
      const res = await axios.get(`${API_URL}/setup/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAllUsers(res.data);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  const fetchDocuments = async () => {
    try {
      const res = await axios.get(`${API_URL}/projects/${id}/documents`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDocuments(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchMilestones = async () => {
    try {
      const res = await axios.get(`${API_URL}/projects/${id}/milestones`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMilestones(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDivisions = async () => {
    try {
      const res = await axios.get(`${API_URL}/setup/divisions`, { headers: { Authorization: `Bearer ${token}` } });
      setDivisions(res.data);
    } catch (err) { console.error(err); }
  };

  const fetchCountries = async () => {
    try {
      const res = await axios.get(`${API_URL}/setup/countries`, { headers: { Authorization: `Bearer ${token}` } });
      setCountries(res.data);
    } catch (err) { console.error(err); }
  };

  const [clientsForContract, setClientsForContract] = useState([]);

  const fetchContracts = async () => {
    try {
      const res = await axios.get(`${API_URL}/contracts?project_id=${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const projectContracts = res.data.filter(c => {
        const pid = parseInt(id);
        return c.project_id === pid || c.project_id === String(pid);
      });
      setContracts(projectContracts);
    } catch (err) { console.error(err); }
  };

  const fetchClientsForContracts = async () => {
    try {
      const [cliRes, projRes] = await Promise.all([
        axios.get(`${API_URL}/clients`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API_URL}/projects`, { headers: { Authorization: `Bearer ${token}` } })
      ]);
      setClientsForContract(cliRes.data);
      setAllProjects(projRes.data);
    } catch (err) { console.error(err); }
  };


  useEffect(() => {
    fetchProject();
    fetchTeam();
    fetchAllUsers();
    fetchDocuments();
    fetchMilestones();
    fetchDivisions();
    fetchCountries();
    fetchContracts();
    if (canViewContracts) {
      fetchClientsForContracts();
    }
  }, [id]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 7) {
      fetchAiReportHistory();
    }
    if (newValue === 8) {
      fetchPayments();
    }
  };

  // --- Payments / Financial ---
  const fetchPayments = async () => {
    try {
      const res = await axios.get(`${API_URL}/projects/${id}/payments`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPayments(res.data);
    } catch (err) {
      console.error('Error fetching payments:', err);
    }
  };

  const handleOpenAddPayment = () => {
    setEditingPayment(null);
    setPaymentForm({ amount: '', payment_date: '', payment_method: '', reference_number: '', status: 'Pending', notes: '' });
    setOpenPaymentDialog(true);
  };

  const handleEditPayment = (pym) => {
    setEditingPayment(pym);
    setPaymentForm({
      amount: pym.amount || '',
      payment_date: pym.payment_date || '',
      payment_method: pym.payment_method || '',
      reference_number: pym.reference_number || '',
      status: pym.status || 'Pending',
      notes: pym.notes || ''
    });
    setOpenPaymentDialog(true);
  };

  const handleSavePayment = async () => {
    setSavingPayment(true);
    try {
      const payload = {
        amount: paymentForm.amount,
        payment_date: paymentForm.payment_date || null,
        payment_method: paymentForm.payment_method,
        reference_number: paymentForm.reference_number,
        status: paymentForm.status,
        notes: paymentForm.notes
      };
      if (editingPayment) {
        await axios.put(`${API_URL}/projects/${id}/payments/${editingPayment.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(`${API_URL}/projects/${id}/payments`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      setOpenPaymentDialog(false);
      setEditingPayment(null);
      fetchPayments();
    } catch (err) {
      console.error('Error saving payment:', err);
      alert(err.response?.data?.message || 'Error saving payment');
    } finally {
      setSavingPayment(false);
    }
  };

  const handleDeletePayment = async (paymentId) => {
    if (!window.confirm('Delete this payment?')) return;
    try {
      await axios.delete(`${API_URL}/projects/${id}/payments/${paymentId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchPayments();
    } catch (err) {
      console.error('Error deleting payment:', err);
      alert('Error deleting payment');
    }
  };

  const openProjectLink = (url) => {
    if (!url) return;
    const normalizedUrl = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    window.open(normalizedUrl, '_blank');
  };

  const handleSaveLocalLink = async () => {
    try {
      await axios.put(`${API_URL}/projects/${id}`, { project_link: tempProjectLink }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProject({ ...project, project_link: tempProjectLink });
      setEditingProjectLink(false);
    } catch (err) {
      console.error(err);
      alert("Error updating Local PC Data Path");
    }
  };

  // --- Edit Project ---
  const handleSaveProject = async () => {
    try {
      await axios.put(`${API_URL}/projects/${id}`, editData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEditMode(false);
      fetchProject();
    } catch (err) {
      console.error(err);
      alert("Error updating project");
    }
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setEditData({
            ...editData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        },
        (error) => {
          console.error("Error getting location:", error);
          alert("Error getting location. Please ensure location services are enabled.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const handleInputChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  // --- Team Management ---
  const handleAssignUser = async () => {
    setAssignLoading(true);
    try {
      await axios.post(`${API_URL}/projects/${id}/team`, {
        user_id: assignUser,
        role: assignRole
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOpenAssignDialog(false);
      fetchTeam();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Error assigning user");
    } finally {
      setAssignLoading(false);
    }
  };

  const handleRemoveUser = async (userId) => {
    if(!window.confirm("Are you sure you want to remove this user?")) return;
    try {
      await axios.delete(`${API_URL}/projects/${id}/team?user_id=${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchTeam();
    } catch (err) {
      console.error(err);
      alert("Error removing user");
    }
  };

  // --- Reports ---
  const handleUpdateReportName = async (reportId) => {
    if (!editingReportName.trim()) return;
    try {
      await axios.put(`${API_URL}/reports/${reportId}`, { name: editingReportName }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEditingReportId(null);
      setEditingReportName('');
      fetchProject();
    } catch (err) {
      console.error(err);
      alert("Error updating report name");
    }
  };

  const handleDeleteReport = async (reportId) => {
    if(!window.confirm("Delete this report folder and all its revisions?")) return;
    try {
      await axios.delete(`${API_URL}/reports/${reportId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchProject();
    } catch (err) {
      console.error(err);
      alert("Error deleting report");
    }
  };

  const handleAddReport = async () => {
    setCreateReportLoading(true);
    try {
      await axios.post(`${API_URL}/projects/${id}/reports`, { name: newReportName }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOpenReportDialog(false);
      setNewReportName('');
      fetchProject(); 
    } catch (err) {
      console.error(err);
    } finally {
      setCreateReportLoading(false);
    }
  };

  const handleAddSubReport = async (reportId) => {
    setAddingRevisionId(reportId);
    try {
        await axios.post(`${API_URL}/reports/${reportId}/subreports`, {}, {
            headers: { Authorization: `Bearer ${token}` }
        });
        await fetchProject();
    } catch (err) {
        console.error(err);
        alert("Error creating subreport");
    } finally {
        setAddingRevisionId(null);
    }
  };

  const handleSaveSubEdit = async () => {
    setSavingSubEdit(true);
    try {
      await axios.put(`${API_URL}/subreports/${editSubDialog.sub.generated_id}`, { submitted_at: editSubDialog.submittedAt || null }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEditSubDialog({ open: false, sub: null, submittedAt: '' });
      await fetchProject();
    } catch (err) {
      alert(err.response?.data?.message || 'Error updating document');
    } finally {
      setSavingSubEdit(false);
    }
  };

  // --- Documents ---
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingFile(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post(`${API_URL}/projects/${id}/documents`, formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      fetchDocuments();
    } catch (err) {
      console.error(err);
      alert("Error uploading file");
    } finally {
      setUploadingFile(false);
    }
  };

  const handleUploadDocument = async () => {
    if (!uploadFile) return;
    const formData = new FormData();
    formData.append('file', uploadFile);

    try {
      await axios.post(`${API_URL}/projects/${id}/documents`, formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      setUploadFile(null);
      fetchDocuments();
    } catch (err) {
      console.error(err);
      alert("Error uploading file");
    }
  };

  // --- Milestones ---
  const handleAddMilestone = async () => {
    try {
      await axios.post(`${API_URL}/projects/${id}/milestones`, {
        name: newMilestoneName,
        due_date: newMilestoneDate,
        description: newMilestoneDesc
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOpenMilestoneDialog(false);
      setNewMilestoneName('');
      setNewMilestoneDate('');
      setNewMilestoneDesc('');
      fetchMilestones();
    } catch (err) {
      console.error(err);
      alert("Error creating milestone");
    }
  };

  const handleUpdateMilestoneStatus = async (milestoneId, status) => {
    const isCompleted = status === 'Completed';
    try {
      await axios.put(`${API_URL}/milestones/${milestoneId}`, {
        completed: isCompleted
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchMilestones();
    } catch (err) {
      console.error(err);
      alert("Error updating milestone");
    }
  };

  const handleToggleMilestone = async (milestoneId, currentStatus) => {
    try {
      await axios.put(`${API_URL}/milestones/${milestoneId}`, {
        completed: !currentStatus
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchMilestones();
    } catch (err) {
      console.error(err);
      alert("Error updating milestone");
    }
  };

  const handleDeleteMilestone = async (milestoneId) => {
    if(!window.confirm("Delete this milestone?")) return;
    try {
      await axios.delete(`${API_URL}/milestones/${milestoneId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchMilestones();
    } catch (err) {
      console.error(err);
      alert("Error deleting milestone");
    }
  };

  const handleSaveEditMilestone = async () => {
    if (!editMilestoneName.trim()) { alert('Name is required'); return; }
    try {
      await axios.put(`${API_URL}/milestones/${editingMilestone}`, {
        name: editMilestoneName,
        due_date: editMilestoneDate,
        description: editMilestoneDesc
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOpenEditMilestoneDialog(false);
      setEditingMilestone(null);
      setEditMilestoneName('');
      setEditMilestoneDate('');
      setEditMilestoneDesc('');
      fetchMilestones();
    } catch (err) {
      console.error(err);
      alert("Error updating milestone");
    }
  };

  const handleViewQR = (url, title) => {
    setQrDialog({ open: true, url, title });
  };

  const handleMemberClick = async (member) => {
    setSelectedMember(member);
    try {
        const res = await axios.get(`${API_URL}/projects/${id}/team/${member.user_id}/hours`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        setMemberHours(res.data);
        setOpenMemberDialog(true);
    } catch (err) {
        console.error(err);
        alert("Failed to fetch member hours");
    }
  };

  const handleUploadClick = (subReportId) => {
    setUploadSubReportId(subReportId);
    if (fileInputRef.current) {
        fileInputRef.current.click();
    }
  };

  const handleSubReportFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file || !uploadSubReportId) return;
    
    const currentUploadId = uploadSubReportId;
    setUploadingSubReportId(currentUploadId);

    const formData = new FormData();
    formData.append('file', file);

    try {
        await axios.post(`${API_URL}/subreports/${currentUploadId}/upload`, formData, {
            headers: { 
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        setUploadSubReportId(null);
        event.target.value = null;
        await fetchProject();
        alert("File uploaded successfully");
    } catch (err) {
        console.error(err);
        alert("Error uploading file");
    } finally {
        setUploadingSubReportId(null);
    }
  };

  const handleDownloadSubReport = (subReportId) => {
      const url = `${API_URL}/subreports/${subReportId}/download`;
      window.open(url, '_blank');
  };

  const handleDownloadDocument = (filename) => {
      const encodedFilename = encodeURIComponent(filename);
      const url = `${API_URL}/projects/${id}/documents/${encodedFilename}`;
      window.open(url, '_blank');
  };

  // --- Contracts ---
  const handleOpenAddContract = () => {
    setNewContract({
      client_id: project.client_id || '',
      country_id: project.country_id || '',
      division_id: project.division_id || '',
      description: '',
      ddp: '',
      file: null
    });
    setOpenAddContract(true);
  };

  const handleCreateContract = async () => {
    setCreateContractLoading(true);
    try {
      const formData = new FormData();
      formData.append('project_id', id);
      formData.append('client_id', newContract.client_id);
      formData.append('country_id', newContract.country_id);
      formData.append('division_id', newContract.division_id);
      formData.append('description', newContract.description);
      formData.append('ddp', newContract.ddp);
      formData.append('document_type', newContract.document_type);
      if (newContract.file) {
        formData.append('contract_pdf', newContract.file);
      }
      await axios.post(`${API_URL}/contracts`, formData, {
        headers: { ...{ Authorization: `Bearer ${token}` }, 'Content-Type': 'multipart/form-data' }
      });
      setOpenAddContract(false);
      fetchContracts();
      setNewContract({ client_id: '', country_id: '', division_id: '', description: '', ddp: '', document_type: '', file: null });
    } catch (err) {
      alert('Error creating contract');
      console.error(err);
    } finally {
      setCreateContractLoading(false);
    }
  };

  const handleCreateReference = async () => {
    const userId = localStorage.getItem('user_id');
    setCreateReferenceLoading(true);
    try {
      const res = await axios.post(`${API_URL}/references`, {
        ...newReference,
        project_id: id,
        user_id: userId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setOpenReferenceDialog(false);
      setNewReference({ type: 'In', subject: '', recipient_to: '', address: '', description: '' });
      fetchProject();
    } catch (err) {
      alert('Error creating reference');
      console.error(err);
    } finally {
      setCreateReferenceLoading(false);
    }
  };

  if (loading || !project) return <Loading message="Loading Project Details..." />;

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden', boxSizing: 'border-box', pb: 6, px: { xs: 1, md: 3 }, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
      
      {/* Modern Gradient Header */}
      <Grow in={true} timeout={500}>
      <Paper elevation={0} sx={{ 
          mb: 4, 
          mt: 2, 
          p: 4, 
          borderRadius: 4, 
          background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
          color: 'white',
          boxShadow: '0 10px 30px rgba(30, 60, 114, 0.2)',
          position: 'relative',
          overflow: 'hidden'
      }}>
        <Box sx={{ position: 'absolute', top: -50, right: -50, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
        <Box sx={{ position: 'absolute', bottom: -100, right: 100, width: 250, height: 250, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />

        <Box sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'flex-start' }, justifyContent: 'space-between', gap: 3 }}> 
            <Box sx={{ flex: 1 }}>
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/projects')}
                sx={{ color: '#90caf9', mb: 2, pl: 0, fontWeight: 'bold', '&:hover': { color: 'white', bgcolor: 'transparent', transform: 'translateX(-4px)' }, transition: 'all 0.2s' }}
              >
                Back to Projects Focus
              </Button>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
                <Avatar sx={{ 
                    width: 52, height: 52, flexShrink: 0,
                    bgcolor: 'rgba(255,255,255,0.15)', 
                    color: '#e3f2fd', 
                    boxShadow: '0 6px 18px rgba(0,0,0,0.2)',
                    border: '2px solid rgba(255,255,255,0.2)',
                }}>
                  <AssignmentIcon sx={{ color: 'white', fontSize: 26 }} />
                </Avatar>
                <Typography variant="h5" fontWeight="900" sx={{ letterSpacing: 0.3, wordBreak: 'break-word', color: 'white', lineHeight: 1.3 }}>
                  {project.name}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', ml: 0.5, mt: 1.5 }}>
                <Box sx={{ 
                  display: 'flex', alignItems: 'center', gap: 0.8, 
                  bgcolor: 'rgba(255,255,255,0.18)', backdropFilter: 'blur(8px)',
                  px: 1.8, py: 0.7, borderRadius: 3,
                  border: '1px solid rgba(255,255,255,0.2)',
                }}>
                  <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#4ade80', boxShadow: '0 0 6px #4ade80' }} />
                  <Typography variant="caption" sx={{ color: 'white', fontWeight: 700, letterSpacing: 0.3, fontSize: '0.75rem' }}>
                    {project.status}
                  </Typography>
                </Box>
                {project.client && (
                    <Box sx={{ 
                      display: 'flex', alignItems: 'center', gap: 0.8, 
                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                      px: 1.8, py: 0.7, borderRadius: 3,
                      border: '1px solid rgba(255,255,255,0.12)',
                    }}>
                      <BusinessIcon sx={{ color: '#93c5fd', fontSize: 14 }} />
                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                        {project.client}
                      </Typography>
                    </Box>
                )}
                {project.ref && (
                    <Box sx={{ 
                      display: 'flex', alignItems: 'center', gap: 0.8, 
                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                      px: 1.8, py: 0.7, borderRadius: 3,
                      border: '1px solid rgba(255,255,255,0.12)',
                    }}>
                      <QrCodeIcon sx={{ color: '#c4b5fd', fontSize: 14 }} />
                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                        {project.ref}
                      </Typography>
                    </Box>
                )}
                {project.division && (
                    <Box sx={{ 
                      display: 'flex', alignItems: 'center', gap: 0.8, 
                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                      px: 1.8, py: 0.7, borderRadius: 3,
                      border: '1px solid rgba(255,255,255,0.12)',
                    }}>
                      <FolderIcon sx={{ color: '#fde68a', fontSize: 14 }} />
                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                        {project.division}
                      </Typography>
                    </Box>
                )}
                {project.country && (
                    <Box sx={{ 
                      display: 'flex', alignItems: 'center', gap: 0.8, 
                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                      px: 1.8, py: 0.7, borderRadius: 3,
                      border: '1px solid rgba(255,255,255,0.12)',
                    }}>
                      <PublicIcon sx={{ color: '#86efac', fontSize: 14 }} />
                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                        {project.country}
                      </Typography>
                    </Box>
                )}
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', md: 'auto' }, pt: { xs: 2, md: 0 }, alignItems: { xs: 'flex-start', md: 'center' } }}>
                <Button
                    variant="contained"
                    startIcon={editMode ? <CloseIcon /> : <EditIcon />}
                    onClick={() => setEditMode(!editMode)}
                    sx={{
                        borderRadius: 2,
                        bgcolor: editMode ? 'rgba(244,67,54,0.9)' : 'white',
                        color: editMode ? 'white' : '#1e3c72',
                        fontWeight: 'bold',
                        px: 3,
                        boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
                        '&:hover': { 
                            bgcolor: editMode ? '#d32f2f' : '#f0f0f0',
                            transform: 'translateY(-2px)'
                        },
                        transition: 'all 0.2s',
                        height: 'fit-content'
                    }}
                >
                    {editMode ? 'Cancel Edit' : 'Edit Project'}
                </Button>

                {project?.project_link && (
                    <Button variant="contained" startIcon={<OpenInNewIcon />}
                        onClick={() => openProjectLink(project.project_link)}
                        sx={{ borderRadius: 2, bgcolor: 'rgba(16, 185, 129, 0.9)', color: 'white', fontWeight: 'bold', px: 3, boxShadow: '0 4px 14px rgba(0,0,0,0.2)', '&:hover': { bgcolor: '#059669', transform: 'translateY(-2px)' }, transition: 'all 0.2s', height: 'fit-content' }}>Open Path</Button>
                )}

                {/* QR Code Box */}
                <Box sx={{ 
                    bgcolor: 'rgba(255,255,255,0.1)', 
                    backdropFilter: 'blur(10px)',
                    p: 1.5, 
                    borderRadius: 3, 
                    border: '1px solid rgba(255,255,255,0.2)',
                    textAlign: 'center',
                    alignSelf: { xs: 'flex-start', md: 'center' },
                    mt: { xs: 3, md: 0 }
                }}>
                    <Box sx={{ bgcolor: 'white', p: 1, borderRadius: 2 }}>
                        <img 
                            src={`${API_URL}/projects/${id}/qr`} 
                            alt="QR Code" 
                            style={{ width: 100, height: 100, display: 'block', borderRadius: 4 }} 
                        />
                    </Box>
                    <Typography variant="caption" sx={{ color: 'white', fontSize: '0.7rem', mt: 1, display: 'block', fontWeight: '800', letterSpacing: 1 }}>
                        SCAN QR
                    </Typography>
                </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
      </Grow>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', minHeight: '400px', bgcolor: 'white', border: '1px solid #f0f0f0' }}>
            <Tabs 
              value={tabValue} 
              onChange={handleTabChange} 
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{ sx: { height: 3, borderRadius: '3px 3px 0 0' } }}
              sx={{ 
                  borderBottom: 1, 
                  borderColor: '#f0f0f0', 
                  bgcolor: 'white', 
                  px: 2,
                  '& .MuiTab-root': { fontWeight: 700, textTransform: 'none', minHeight: 64, fontSize: '0.95rem' }
              }}
            >
              <Tab icon={<AssignmentIcon />} label="Overview" iconPosition="start" />
              <Tab icon={<PersonAddIcon />} label="Team" iconPosition="start" />
              <Tab icon={<InsertDriveFileIcon />} label="Reports" iconPosition="start" />
              <Tab icon={<CloudUploadIcon />} label="Documents" iconPosition="start" />
              <Tab icon={<EventIcon />} label="Milestones" iconPosition="start" />
              <Tab icon={<BookmarksIcon />} label="References" iconPosition="start" />
              {canViewContracts && <Tab icon={<DescriptionIcon />} label="Contracts" iconPosition="start" />}
              <Tab icon={<AutoAwesomeIcon />} label="AI Reports" iconPosition="start" />
              <Tab icon={<AttachMoneyIcon />} label="Financial" iconPosition="start" />
            </Tabs>

            {/* Overview Tab */}
            <TabPanel value={tabValue} index={0}>
            {editMode ? (
                <Card elevation={0} sx={{ borderRadius: 4, border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0,0,0,0.02)', bgcolor: 'white', overflow: 'hidden' }}>
                    <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4, pb: 2, borderBottom: '2px solid #f1f5f9' }}>
                            <EditIcon sx={{ color: '#1e3c72', fontSize: 28 }} />
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Edit Project Details</Typography>
                            <Box sx={{ flexGrow: 1 }} />
                            <Chip label={`ID: ${project.id}`} size="small" sx={{ fontWeight: 700, bgcolor: '#eff6ff', color: '#1e40af', borderRadius: 1.5 }} />
                        </Box>
                        
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <TextField 
                                    fullWidth 
                                    label="Project Name" 
                                    name="name" 
                                    value={editData.name || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField 
                                    fullWidth 
                                    label="Quote Reference" 
                                    name="quote_ref" 
                                    value={editData.quote_ref || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Description"
                                    fullWidth multiline rows={4}
                                    name="description"
                                    value={editData.description || ''}
                                    onChange={handleInputChange}
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Grid>
                            
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, mb: 2 }}>
                                    Project Classification
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#f8fafc' } }}>
                                    <InputLabel>Status</InputLabel>
                                    <Select label="Status" name="status" value={editData.status || ''} onChange={handleInputChange}>
                                        <MenuItem value="Active">Active</MenuItem>
                                        <MenuItem value="In Progress">In Progress</MenuItem>
                                        <MenuItem value="Bid Stage">Bid Stage</MenuItem>
                                        <MenuItem value="At Risk">At Risk</MenuItem>
                                        <MenuItem value="On Hold">On Hold</MenuItem>
                                        <MenuItem value="Submitted">Submitted</MenuItem>
                                        <MenuItem value="Under Review">Under Review</MenuItem>
                                        <MenuItem value="Overdue">Overdue</MenuItem>
                                        <MenuItem value="Completed">Completed</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#f8fafc' } }}>
                                    <InputLabel>Current Stage</InputLabel>
                                    <Select label="Current Stage" name="stage" value={editData.stage || 'Planning'} onChange={handleInputChange}>
                                        <MenuItem value="Planning">Planning</MenuItem>
                                        <MenuItem value="Site Work">Site Work</MenuItem>
                                        <MenuItem value="Reporting">Reporting</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#f8fafc' } }}>
                                    <InputLabel>Priority</InputLabel>
                                    <Select label="Priority" name="priority" value={editData.priority || 'Medium'} onChange={handleInputChange}>
                                        <MenuItem value="Low">Low</MenuItem>
                                        <MenuItem value="Medium">Medium</MenuItem>
                                        <MenuItem value="High">High</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider sx={{ borderColor: '#f1f5f9', my: 1 }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, mt: 2, mb: 2 }}>
                                    Schedule & Budget
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField 
                                    fullWidth 
                                    type="date" 
                                    label="Start Date" 
                                    name="start_date" 
                                    value={editData.start_date || ''} 
                                    onChange={handleInputChange} 
                                    InputLabelProps={{ shrink: true }} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField 
                                    fullWidth 
                                    type="date" 
                                    label="Deadline" 
                                    name="deadline" 
                                    value={editData.deadline || ''} 
                                    onChange={handleInputChange} 
                                    InputLabelProps={{ shrink: true }} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField 
                                    fullWidth 
                                    type="number" 
                                    label="Budget ($)" 
                                    name="budget" 
                                    value={editData.budget || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                    InputProps={{ startAdornment: <InputAdornment position="start"><AttachMoneyIcon sx={{ color: '#94a3b8', fontSize: 18 }} /></InputAdornment> }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField 
                                    fullWidth 
                                    type="number" 
                                    label="Spent ($)" 
                                    name="spent" 
                                    value={editData.spent || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                    InputProps={{ startAdornment: <InputAdornment position="start"><AttachMoneyIcon sx={{ color: '#94a3b8', fontSize: 18 }} /></InputAdornment> }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField 
                                    fullWidth 
                                    type="number" 
                                    label="Quote Won Value ($)" 
                                    name="quote_won_value" 
                                    value={editData.quote_won_value || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                    InputProps={{ startAdornment: <InputAdornment position="start"><AttachMoneyIcon sx={{ color: '#10b981', fontSize: 18 }} /></InputAdornment> }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField 
                                    fullWidth 
                                    type="number" 
                                    label="Progress %" 
                                    name="progress" 
                                    value={editData.progress || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Divider sx={{ borderColor: '#f1f5f9', my: 1 }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.5, mt: 2, mb: 2 }}>
                                    Location & Organization
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#f8fafc' } }}>
                                    <InputLabel>Country</InputLabel>
                                    <Select label="Country" value={editData.country_id || ''} onChange={e => setEditData({ ...editData, country_id: e.target.value })}>
                                        {countries.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#f8fafc' } }}>
                                    <InputLabel>Division</InputLabel>
                                    <Select label="Division" value={editData.division_id || ''} onChange={e => setEditData({ ...editData, division_id: e.target.value })}>
                                        {divisions.map(d => <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField 
                                    fullWidth 
                                    type="number" 
                                    label="Latitude" 
                                    name="latitude" 
                                    value={editData.latitude || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                    InputProps={{ startAdornment: <InputAdornment position="start"><MyLocationIcon sx={{ color: '#94a3b8', fontSize: 18 }} /></InputAdornment> }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField 
                                    fullWidth 
                                    type="number" 
                                    label="Longitude" 
                                    name="longitude" 
                                    value={editData.longitude || ''} 
                                    onChange={handleInputChange} 
                                    sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                                <Button size="small" sx={{ mt: 1, borderRadius: 2, fontWeight: 600, color: '#1e3c72', borderColor: '#1e3c72' }} variant="outlined" startIcon={<MyLocationIcon />} onClick={getLocation}>
                                    Use My Location
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>

                    <Box sx={{ p: { xs: 2, md: 3 }, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9', display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                        <Button 
                            variant="outlined" 
                            size="large" 
                            onClick={() => setEditMode(false)}
                            sx={{ color: '#64748b', fontWeight: 600, borderRadius: 2, borderColor: '#e2e8f0', '&:hover': { borderColor: '#94a3b8', bgcolor: '#f1f5f9' } }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSaveProject}
                            startIcon={<SaveIcon />}
                            size="large"
                            sx={{ 
                                borderRadius: 2, 
                                px: 4, 
                                fontWeight: 'bold', 
                                bgcolor: '#1e3c72',
                                boxShadow: '0 4px 14px rgba(30, 60, 114, 0.3)',
                                '&:hover': { bgcolor: '#152b53', transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(30, 60, 114, 0.4)' }
                            }}
                        >
                            Save Changes
                        </Button>
                    </Box>
                </Card>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* Info Cards Grid */}
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                        <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                            <CardContent sx={{ p: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                                <BusinessIcon sx={{ color: '#3b82f6' }} />
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Client Details</Typography>
                            </Box>
                            
                            <Box sx={{ p: 3, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0' }}>
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', display: 'block', mb: 1 }}>Client Name</Typography>
                                {project.client && project.client_id ? (
                                  <Typography 
                                    variant="body1" 
                                    sx={{ fontWeight: 800, color: '#2563eb', mb: 2, cursor: 'pointer', textDecoration: 'underline', '&:hover': { color: '#1d4ed8' } }}
                                    onClick={() => navigate(`/clients/${project.client_id}`)}
                                  >
                                    {project.client}
                                  </Typography>
                                ) : (
                                  <Typography variant="body1" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>{project.client || 'N/A'}</Typography>
                                )}
                                
                                <Divider sx={{ my: 2, borderColor: '#e2e8f0' }} />
                                
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>Quote Reference</Typography>
                                    <Chip label={project.quote_ref || 'N/A'} size="small" sx={{ borderRadius: 1.5, fontWeight: 700, bgcolor: '#eff6ff', color: '#1e40af' }} />
                                </Box>
                            </Box>
                            </CardContent>
                        </Card>
                        </Grid>

                        <Grid item xs={12} md={6}>
                        <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                            <CardContent sx={{ p: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                                <AssignmentIcon sx={{ color: '#2563eb' }} />
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Project Health</Typography>
                            </Box>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ textAlign: 'center', p: 2.5, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0', transition: 'all 0.2s', '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f1f5f9' } }}>
                                        <Typography variant="caption" color="#64748b" fontWeight="bold" textTransform="uppercase" letterSpacing={1}>Current Status</Typography>
                                        <Typography variant="h6" fontWeight="800" color="#334155" mt={1}>{project.status || 'N/A'}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ textAlign: 'center', p: 2.5, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0', transition: 'all 0.2s', '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f1f5f9' } }}>
                                        <Typography variant="caption" color="#64748b" fontWeight="bold" textTransform="uppercase" letterSpacing={1}>Current Stage</Typography>
                                        <Typography variant="h6" fontWeight="800" color="#334155" mt={1}>{project.stage || 'Planning'}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ textAlign: 'center', p: 2.5, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0', transition: 'all 0.2s', '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f1f5f9' } }}>
                                        <Typography variant="caption" color="#64748b" fontWeight="bold" textTransform="uppercase" letterSpacing={1}>Priority Level</Typography>
                                        <Typography variant="h6" fontWeight="800" color="#334155" mt={1}>{project.priority || 'Medium'}</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            </CardContent>
                        </Card>
                        </Grid>

                        <Grid item xs={12} md={6}>
                        <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                            <CardContent sx={{ p: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                                <FlagIcon sx={{ color: '#2563eb' }} />
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Progress Tracking</Typography>
                            </Box>
                            <Box sx={{ mt: 2, mb: 3 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: '#64748b' }}>Completion</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 800, color: '#2563eb' }}>{Math.round(project.progress || 0)}%</Typography>
                                </Box>
                                <LinearProgress 
                                variant="determinate" 
                                value={Number(project.progress || 0)} 
                                sx={{ height: 8, borderRadius: 4, bgcolor: '#e2e8f0', '& .MuiLinearProgress-bar': { borderRadius: 4, bgcolor: '#2563eb' } }} 
                                />
                            </Box>
                            </CardContent>
                        </Card>
                        </Grid>

                        <Grid item xs={12} md={6}>
                        <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                            <CardContent sx={{ p: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                                <EventIcon sx={{ color: '#2563eb' }} />
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Key Dates</Typography>
                            </Box>
                            <Grid container spacing={4}>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5 }}>
                                        <Avatar sx={{ bgcolor: '#eff6ff', color: '#3b82f6', width: 44, height: 44, boxShadow: '0 2px 10px rgba(59,130,246,0.15)' }}>
                                            <EventIcon />
                                        </Avatar>
                                        <Box>
                                            <Typography variant="caption" color="#64748b" fontWeight="700" textTransform="uppercase" letterSpacing={0.5}>Start Date</Typography>
                                            <Typography variant="body1" fontWeight="600" color="#1e293b">{project.start_date || "Not set"}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5 }}>
                                        <Avatar sx={{ bgcolor: '#fef2f2', color: '#ef4444', width: 44, height: 44, boxShadow: '0 2px 10px rgba(239,68,68,0.15)' }}>
                                            <FlagIcon />
                                        </Avatar>
                                        <Box>
                                            <Typography variant="caption" color="#64748b" fontWeight="700" textTransform="uppercase" letterSpacing={0.5}>Deadline</Typography>
                                            <Typography variant="body1" fontWeight="600" color="#1e293b">{project.deadline || "Not set"}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5 }}>
                                        <Avatar sx={{ bgcolor: '#f0fdf4', color: '#22c55e', width: 44, height: 44, boxShadow: '0 2px 10px rgba(34,197,94,0.15)' }}>
                                            <AccessTimeIcon />
                                        </Avatar>
                                        <Box>
                                            <Typography variant="caption" color="#64748b" fontWeight="700" textTransform="uppercase" letterSpacing={0.5}>Created On</Typography>
                                            <Typography variant="body1" fontWeight="600" color="#1e293b">{project.created_at}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                            </CardContent>
                        </Card>
                        </Grid>

                        <Grid item xs={12}>
                        <Card elevation={0} sx={{ borderRadius: 4, boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                            <CardContent sx={{ p: 4 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <MapIcon sx={{ color: '#2563eb' }} />
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Project Location</Typography>
                            </Box>
                            </Box>
                            
                                {project.latitude && project.longitude ? (
                                    <Box sx={{ height: 400, borderRadius: 3, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                                        <MapContainer 
                                            center={[project.latitude, project.longitude]} 
                                            zoom={15} 
                                            style={{ height: '100%', width: '100%' }}
                                            scrollWheelZoom={true}
                                        >
                                            <TileLayer
                                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                            <Marker position={[project.latitude, project.longitude]} />
                                        </MapContainer>
                                    </Box>
                                ) : (
                                    <Box sx={{ p: 6, textAlign: 'center', bgcolor: 'white', borderRadius: 3, border: '1px dashed #cbd5e1' }}>
                                        <PublicIcon sx={{ fontSize: 48, color: '#94a3b8', mb: 2 }} />
                                        <Typography variant="body1" sx={{ color: '#64748b', fontWeight: 500 }}>
                                            Location data: None set
                                        </Typography>
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                        </Grid>
                    </Grid>
                </Box>
            )}
            </TabPanel>

            {/* Team Tab */}
            <TabPanel value={tabValue} index={1}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Team Members</Typography>
                <Button 
                    variant="contained" 
                    startIcon={<PersonAddIcon />} 
                    onClick={() => setOpenAssignDialog(true)}
                    sx={{ 
                        borderRadius: 2, 
                        fontWeight: 'bold', 
                        px: 3, 
                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                    }}
                >
                  Add Member
                </Button>
              </Box>
              <Grid container spacing={3}>
                {team.map((member) => (
                  <Grid item xs={12} sm={6} md={4} key={member.user_id}>
                    <Card 
                      elevation={0}
                      sx={{ 
                        borderRadius: 4,
                        border: '1px solid #f1f5f9',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 24px -4px rgba(148, 163, 184, 0.15)', borderColor: '#e2e8f0' }
                      }}
                      onClick={() => handleMemberClick(member)}
                    >
                      <CardContent sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mb: 2.5 }}>
                            <Avatar sx={{ bgcolor: '#eff6ff', color: '#0ea5e9', fontWeight: 800, width: 56, height: 56, border: '2px solid white', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>{member.name[0]}</Avatar>
                            <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#1e293b', mb: 0.5 }} noWrap>{member.name}</Typography>
                                <Chip label={member.role} size="small" sx={{ height: 22, fontSize: '0.7rem', fontWeight: 800, bgcolor: '#f1f5f9', color: '#475569', borderRadius: 1.5 }} />
                            </Box>
                        </Box>
                        
                        <Divider sx={{ my: 2, borderStyle: 'dashed' }} />
                        
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#64748b' }}>
                                <AccessTimeIcon fontSize="small" sx={{ opacity: 0.7 }} />
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>{member.total_hours || 0} Hrs</Typography>
                            </Box>
                            <IconButton 
                                size="small" 
                                onClick={(e) => { 
                                e.stopPropagation(); 
                                handleRemoveUser(member.user_id); 
                                }} 
                                sx={{ bgcolor: '#fef2f2', color: '#ef4444', '&:hover': { bgcolor: '#fee2e2', color: '#b91c1c' } }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
                {(!team || team.length === 0) && (
                  <Grid item xs={12}>
                    <Paper elevation={0} sx={{ p: 8, textAlign: 'center', bgcolor: '#f8fafc', borderRadius: 4, border: '2px dashed #cbd5e1' }}>
                      <PersonAddIcon sx={{ fontSize: 64, color: '#94a3b8', mb: 2, opacity: 0.5 }} />
                      <Typography variant="h6" sx={{ color: '#475569', fontWeight: 700, mb: 1 }}>No team members assigned</Typography>
                      <Typography variant="body2" sx={{ color: '#94a3b8', mb: 3 }}>Add members to track hours and manage tasks.</Typography>
                      <Button variant="outlined" onClick={() => setOpenAssignDialog(true)} sx={{ borderRadius: 2, fontWeight: 700, borderWidth: 2, '&:hover': { borderWidth: 2 } }}>Assign Someone</Button>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </TabPanel>

            {/* Reports Tab */}
            <TabPanel value={tabValue} index={2}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Project Reports</Typography>
                <Button 
                    variant="contained" 
                    startIcon={<AddIcon />} 
                    onClick={() => setOpenReportDialog(true)} 
                    sx={{ 
                        borderRadius: 2, 
                        fontWeight: 'bold', 
                        textTransform: 'none',
                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                    }}
                >
                  New Report Folder
                </Button>
              </Box>
              
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {project.reports && project.reports.map((report) => (
                <Accordion 
                    key={report.id} 
                    disableGutters 
                    elevation={0} 
                    sx={{ 
                        border: '1px solid #f1f5f9', 
                        borderRadius: '16px !important', 
                        overflow: 'hidden',
                        '&:before': { display: 'none' },
                        mb: 2,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.02)'
                    }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: 'white', '&:hover': { bgcolor: '#f8fafc' }, px: 3, py: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', pr: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ bgcolor: '#fff7ed', color: '#f97316', width: 44, height: 44, border: '2px solid white', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                            <FolderIcon />
                        </Avatar>
                        <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {editingReportId === report.id ? (
                                    <TextField 
                                        size="small" 
                                        value={editingReportName} 
                                        onChange={(e) => setEditingReportName(e.target.value)} 
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleUpdateReportName(report.id);
                                            }
                                            if (e.key === 'Escape') setEditingReportId(null);
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        autoFocus
                                        sx={{ bgcolor: 'white', borderRadius: 1 }}
                                    />
                                ) : (
                                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#1e293b' }}>{report.name}</Typography>
                                )}
                                
                                {editingReportId === report.id ? (
                                    <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleUpdateReportName(report.id); }} color="primary">
                                        <CheckCircleIcon fontSize="small" />
                                    </IconButton>
                                ) : (
                                    <IconButton size="small" onClick={(e) => { e.stopPropagation(); setEditingReportId(report.id); setEditingReportName(report.name); }}>
                                        <EditIcon fontSize="small" sx={{ color: '#94a3b8' }} />
                                    </IconButton>
                                )}
                                <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDeleteReport(report.id); }}>
                                    <DeleteIcon fontSize="small" sx={{ color: '#ef4444' }} />
                                </IconButton>
                            </Box>
                        </Box>
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ px: 3, py: 2, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                      <Button 
                        variant="contained" 
                        size="small" 
                        sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            textTransform: 'none', 
                            boxShadow: 'none', 
                            bgcolor: '#ebf5ff', 
                            color: '#0284c7', 
                            '&:hover': { bgcolor: '#e0f2fe', color: '#0369a1', boxShadow: '0 4px 12px rgba(14, 165, 233, 0.2)' } 
                        }}
                        startIcon={addingRevisionId === report.id ? <CircularProgress size={20} color="inherit" /> : <AddIcon />} 
                        onClick={() => handleAddSubReport(report.id)}
                        disabled={addingRevisionId === report.id}
                      >
                        {addingRevisionId === report.id ? 'Creating...' : 'Create New Revision'}
                      </Button>
                    </Box>
                    <TableContainer sx={{ overflowX: 'auto', bgcolor: 'white', borderRadius: 3, border: '1px solid #f1f5f9' }}>
                    <Table size="small" sx={{ minWidth: 600 }}>
                      <TableHead sx={{ bgcolor: '#f1f5f9' }}>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', py: 2 }}>Document ID</TableCell>
                          <TableCell sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', py: 2 }}>Revision</TableCell>
                          <TableCell sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', py: 2 }}>Status</TableCell>
                          <TableCell sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', py: 2 }}>Created On</TableCell>
                          <TableCell sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', py: 2 }}>Submitted On</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 800, color: '#64748b', textTransform: 'uppercase', py: 2 }}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {report.subreports && report.subreports.map(sub => (
                          <TableRow key={sub.id} hover sx={{ bgcolor: 'white', '&:last-child td': { borderBottom: 0 } }}>
                            <TableCell sx={{ fontFamily: 'monospace', fontWeight: 700, color: '#334155' }}>{sub.generated_id}</TableCell>
                            <TableCell>
                              <Chip label={`Rev ${sub.revision}`} size="small" sx={{ bgcolor: '#f1f5f9', color: '#1e293b', borderRadius: 1.5, fontWeight: 800 }} />
                            </TableCell>
                            <TableCell>
                                {sub.has_file ? 
                                    <Chip icon={<CheckCircleIcon />} label="Uploaded" size="small" sx={{ bgcolor: '#dcfce7', color: '#166534', fontWeight: 700, border: '1px solid #bbf7d0' }} /> : 
                                    <Chip label="Pending File" size="small" sx={{ bgcolor: '#fff7ed', color: '#c2410c', fontWeight: 700, border: '1px solid #ffedd5' }} />
                                }
                            </TableCell>
                            <TableCell sx={{ color: '#64748b', fontSize: '0.85rem' }}>{sub.created_at || '—'}</TableCell>
                            <TableCell sx={{ color: '#64748b', fontSize: '0.85rem' }}>{sub.submitted_at || '—'}</TableCell>
                            <TableCell align="right">
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                <Tooltip title="Edit">
                                  <IconButton size="small" sx={{ color: '#f59e0b', bgcolor: '#fffbeb', '&:hover': { bgcolor: '#fef3c7' } }} onClick={() => setEditSubDialog({ open: true, sub, submittedAt: sub.submitted_at || '' })}>
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="View QR">
                                  <IconButton size="small" sx={{ color: '#0ea5e9', bgcolor: '#f0f9ff', '&:hover': { bgcolor: '#e0f2fe' } }} onClick={() => handleViewQR(`${API_URL}/subreports/${sub.generated_id}/qr`, sub.generated_id)}>
                                    <QrCodeIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Upload PDF">
                                  <span>
                                    <IconButton 
                                      size="small" 
                                      onClick={() => handleUploadClick(sub.generated_id)} 
                                      sx={{ color: '#8b5cf6', bgcolor: '#f5f3ff', '&:hover': { bgcolor: '#ede9fe' } }}
                                      disabled={uploadingSubReportId === sub.generated_id}
                                    >
                                      {uploadingSubReportId === sub.generated_id ? <CircularProgress size={20} /> : <CloudUploadIcon fontSize="small" />}
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                <Tooltip title="Download PDF">
                                  <span>
                                    <IconButton size="small" disabled={!sub.has_file} sx={{ color: sub.has_file ? '#10b981' : '#cbd5e1', bgcolor: sub.has_file ? '#d1fae5' : 'transparent', '&:hover': { bgcolor: sub.has_file ? '#a7f3d0' : 'transparent' } }} onClick={() => handleDownloadSubReport(sub.generated_id)}>
                                      <DownloadIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                        {(!report.subreports || report.subreports.length === 0) && (
                          <TableRow>
                            <TableCell colSpan={6} align="center" sx={{ py: 6, color: '#94a3b8' }}>
                                <DescriptionIcon sx={{ fontSize: 48, color: '#cbd5e1', mb: 2, opacity: 0.5 }} />
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>No revisions created yet.</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              ))}
              {(!project.reports || project.reports.length === 0) && (
                <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
                    <FolderIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                    <Typography variant="h6" color="#64748b" fontWeight="700" mb={1}>No Reports Found</Typography>
                    <Typography variant="body2" color="#94a3b8">You have not created any reports yet. Click on "New Report Folder" to set up your first report.</Typography>
                </Paper>
              )}
              </Box>
            </TabPanel>

            {/* Documents Tab */}
            <TabPanel value={tabValue} index={3}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Project Documents</Typography>
                <Button 
                    variant="contained" 
                    startIcon={uploadingFile ? <CircularProgress size={20} color="inherit" /> : <CloudUploadIcon />} 
                    component="label"
                    sx={{ 
                        borderRadius: 2, 
                        fontWeight: 'bold', 
                        textTransform: 'none',
                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                    }}
                    disabled={uploadingFile}
                >
                  Upload Document
                  <input type="file" hidden onChange={handleFileUpload} />
                </Button>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Card elevation={0} sx={{ borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: '#f8fafc' }}>
                        <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
                                <FolderIcon sx={{ color: '#0f172a', fontSize: 32 }} />
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase' }}>Local PC Data Path</Typography>
                                    {editingProjectLink ? (
                                        <TextField 
                                            fullWidth
                                            size="small"
                                            value={tempProjectLink}
                                            onChange={(e) => setTempProjectLink(e.target.value)}
                                            placeholder="e.g. C:\Projects\Data or \\server\folder"
                                            sx={{ mt: 1, bgcolor: 'white' }}
                                        />
                                    ) : (
                                        <Typography 
                                            variant="body1" 
                                            sx={{ 
                                                fontWeight: 600, 
                                                color: project?.project_link ? '#2563eb' : '#0f172a',
                                                cursor: project?.project_link ? 'pointer' : 'default',
                                                textDecoration: project?.project_link ? 'underline' : 'none',
                                                '&:hover': project?.project_link ? { color: '#1d4ed8' } : {}
                                            }}
                                            onClick={() => openProjectLink(project?.project_link)}
                                        >
                                            {project?.project_link || 'No local path configured.'}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, ml: 2 }}>
                                {editingProjectLink ? (
                                    <>
                                        <Button variant="contained" onClick={handleSaveLocalLink} sx={{ borderRadius: 2, fontWeight: 'bold' }}>Save</Button>
                                        <Button variant="outlined" onClick={() => setEditingProjectLink(false)} sx={{ borderRadius: 2, fontWeight: 'bold' }}>Cancel</Button>
                                    </>
                                ) : (
                                    <Button 
                                        variant="outlined" 
                                        startIcon={<EditIcon />} 
                                        onClick={() => { setTempProjectLink(project?.project_link || ''); setEditingProjectLink(true); }}
                                        sx={{ borderRadius: 2, fontWeight: 'bold' }}
                                    >
                                        Edit
                                    </Button>
                                )}
                                {project?.project_link && !editingProjectLink && (
                                    <Button 
                                        variant="contained"
                                        color="success"
                                        startIcon={<OpenInNewIcon />}
                                        onClick={() => openProjectLink(project.project_link)}
                                        sx={{ borderRadius: 2, fontWeight: 'bold' }}
                                    >
                                        Open Path
                                    </Button>
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                {documents.map((doc, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card
                        elevation={0}
                        sx={{
                            borderRadius: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            transition: 'all 0.3s ease',
                            border: '1px solid #f1f5f9',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                            '&:hover': { 
                                transform: 'translateY(-6px)', 
                                boxShadow: '0 12px 28px rgba(0,0,0,0.08)', 
                                borderColor: '#3b82f6' 
                            }
                        }}
                    >
                      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', pt: 5, pb: 3 }}>
                        <Box sx={{ 
                            p: 2, 
                            borderRadius: '50%', 
                            bgcolor: '#eff6ff', 
                            mb: 3,
                            boxShadow: 'inset 0 2px 4px rgba(59,130,246,0.1)'
                        }}>
                            <InsertDriveFileIcon sx={{ fontSize: 40, color: '#2563eb' }} />
                        </Box>
                        <Typography variant="subtitle1" fontWeight="800" color="#1e293b" noWrap sx={{ width: '100%', mb: 1.5 }} title={doc}>
                            {doc}
                        </Typography>
                        <Chip label="Document File" size="small" sx={{ bgcolor: '#f8fafc', color: '#64748b', fontWeight: 700, borderRadius: 1.5, border: '1px solid #e2e8f0' }} />
                      </CardContent>
                      <CardActions sx={{ justifyContent: 'center', p: 2.5, bgcolor: '#ffffff', borderTop: '1px solid #f1f5f9' }}>
                        <Button 
                            size="small" 
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            onClick={() => handleDownloadDocument(doc)}
                            fullWidth
                            sx={{ 
                              borderRadius: 2, fontWeight: 'bold', 
                              boxShadow: 'none', background: '#ebf5ff', color: '#2563eb', 
                              '&:hover': { background: '#2563eb', color: 'white', boxShadow: '0 4px 12px rgba(37,99,235,0.2)' } 
                            }}
                        >
                            Download
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
                
                {documents.length === 0 && (
                  <Grid item xs={12}>
                    <Paper 
                        elevation={0}
                        sx={{ 
                            p: 8, 
                            textAlign: 'center', 
                            bgcolor: '#f8fafc', 
                            borderRadius: 4, 
                            border: '2px dashed #cbd5e1', 
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            '&:hover': { borderColor: '#2563eb', bgcolor: '#eff6ff' }
                        }}
                        component="label"
                    >
                      <CloudUploadIcon sx={{ fontSize: 64, color: '#94a3b8', mb: 2, opacity: 0.5 }} />
                      <Typography variant="h6" sx={{ color: '#475569', fontWeight: 700, mb: 1 }}>No Documents Uploaded</Typography>
                      <Typography variant="body2" sx={{ color: '#94a3b8', mb: 4 }}>
                        Upload specifications, contracts, or other project files here.
                      </Typography>
                      <Button variant="contained" component="span" startIcon={<CloudUploadIcon />} 
                          sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            textTransform: 'none',
                            boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                            background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                            '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                          }}
                      >
                        Browse Files
                      </Button>
                      <input type="file" hidden onChange={handleFileUpload} />
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </TabPanel>

            {/* Milestones Tab */}
            <TabPanel value={tabValue} index={4}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Project Milestones</Typography>
                <Button 
                    variant="contained" 
                    startIcon={<AddIcon />} 
                    onClick={() => setOpenMilestoneDialog(true)} 
                    sx={{ 
                        borderRadius: 2, 
                        fontWeight: 'bold', 
                        textTransform: 'none',
                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                    }}
                >
                  Add Milestone
                </Button>
              </Box>

              <Box sx={{ position: 'relative' }}>
                {milestones && milestones.length > 0 && (
                    <Box 
                        sx={{ 
                            position: 'absolute', 
                            left: 36, 
                            top: 30, 
                            bottom: 30, 
                            width: 2, 
                            bgcolor: '#e2e8f0', 
                            zIndex: 0,
                            display: { xs: 'none', md: 'block' }
                        }} 
                    />
                )}
                
                <Grid container spacing={3}>
                    {milestones && milestones.map((milestone, index) => (
                    <Grid item xs={12} key={milestone.id}>
                        <Card 
                            elevation={0}
                            sx={{ 
                                display: 'flex', 
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: { md: 'center' },
                                p: 3,
                                borderRadius: 4,
                                border: '1px solid #f1f5f9',
                                borderLeft: `6px solid ${milestone.completed ? '#10b981' : '#3b82f6'}`,
                                ml: { md: 8 },
                                position: 'relative',
                                overflow: 'visible',
                                transition: 'transform 0.2s',
                                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 12px 24px -4px rgba(148, 163, 184, 0.1)' }
                            }}
                        >
                            <Box 
                                sx={{ 
                                    position: 'absolute', 
                                    left: -48, 
                                    top: '50%', 
                                    transform: 'translateY(-50%)',
                                    width: 18, 
                                    height: 18, 
                                    borderRadius: '50%', 
                                    bgcolor: milestone.completed ? '#10b981' : '#3b82f6',
                                    border: '4px solid white',
                                    boxShadow: '0 0 0 2px #e2e8f0',
                                    zIndex: 1,
                                    display: { xs: 'none', md: 'block' }
                                }} 
                            />

                            <Box sx={{ flexGrow: 1, ml: 1 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>{milestone.name}</Typography>
                                    <Chip 
                                        label={milestone.completed ? 'Completed' : 'In Progress'} 
                                        sx={{ 
                                            bgcolor: milestone.completed ? '#dcfce7' : '#eff6ff', 
                                            color: milestone.completed ? '#166534' : '#1e40af', 
                                            fontWeight: 800, 
                                            borderRadius: 2 
                                        }} 
                                        size="small" 
                                        icon={milestone.completed ? <CheckCircleIcon sx={{ color: '#166534 !important' }} /> : <AccessTimeIcon sx={{ color: '#1e40af !important' }} />}
                                    />
                                </Box>
                                <Typography variant="body1" sx={{ color: '#475569', mb: 3, fontWeight: 500, lineHeight: 1.6 }}>
                                    {milestone.description || "No description provided."}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#f8fafc', px: 2, py: 1, borderRadius: 2, border: '1px solid #f1f5f9' }}>
                                        <CalendarTodayIcon sx={{ fontSize: 18, color: '#64748b' }} />
                                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                                            Due: {milestone.due_date ? new Date(milestone.due_date).toLocaleDateString() : 'No date'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                            
                            <Divider orientation="vertical" flexItem sx={{ mx: 3, display: { xs: 'none', md: 'block' }, borderStyle: 'dashed' }} />
                            <Divider sx={{ my: 3, display: { xs: 'block', md: 'none' }, borderStyle: 'dashed' }} />

                            <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'flex-end', minWidth: 120 }}>
                                <Tooltip title="Edit Milestone">
                                    <IconButton 
                                        onClick={() => { setEditingMilestone(milestone.id); setEditMilestoneName(milestone.name); setEditMilestoneDate(milestone.due_date || ''); setEditMilestoneDesc(milestone.description || ''); setOpenEditMilestoneDialog(true); }}
                                        sx={{ bgcolor: '#eff6ff', color: '#3b82f6', '&:hover': { bgcolor: '#dbeafe' }, p: 1.5 }}
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Mark Complete">
                                    <IconButton 
                                        disabled={milestone.completed}
                                        onClick={() => handleUpdateMilestoneStatus(milestone.id, 'Completed')}
                                        sx={{ 
                                            bgcolor: milestone.completed ? 'transparent' : '#f0fdf4', 
                                            color: milestone.completed ? '#cbd5e1' : '#16a34a',
                                            '&:hover': { bgcolor: '#dcfce7' },
                                            p: 1.5
                                        }}
                                    >
                                        <CheckCircleIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete Milestone">
                                    <IconButton 
                                        onClick={() => handleDeleteMilestone(milestone.id)}
                                        sx={{ bgcolor: '#fef2f2', color: '#ef4444', '&:hover': { bgcolor: '#fee2e2' }, p: 1.5 }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Card>
                    </Grid>
                    ))}
                </Grid>
                
                {(!milestones || milestones.length === 0) && (
                    <Paper elevation={0} sx={{ p: 8, textAlign: 'center', bgcolor: '#f8fafc', borderRadius: 4, border: '2px dashed #cbd5e1' }}>
                      <FlagIcon sx={{ fontSize: 64, color: '#94a3b8', mb: 2, opacity: 0.5 }} />
                      <Typography variant="h6" sx={{ color: '#475569', fontWeight: 700, mb: 1 }}>No milestones set</Typography>
                      <Typography variant="body2" sx={{ color: '#94a3b8', mb: 4 }}>Add project milestones to track major phases.</Typography>
                      <Button 
                          variant="contained" 
                          startIcon={<AddIcon />} 
                          onClick={() => setOpenMilestoneDialog(true)} 
                          sx={{ 
                              borderRadius: 2, 
                              fontWeight: 'bold', 
                              textTransform: 'none',
                              boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                              background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                              '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                          }}
                      >
                          Add First Milestone
                      </Button>
                    </Paper>
                )}
              </Box>
            </TabPanel>

            {/* References Tab */}
            <TabPanel value={tabValue} index={5}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Project References</Typography>
                <Button 
                    variant="contained" 
                    startIcon={<AddIcon />} 
                    onClick={() => setOpenReferenceDialog(true)} 
                    sx={{ 
                        borderRadius: 2, 
                        fontWeight: 'bold', 
                        textTransform: 'none',
                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                    }}
                >
                  Add Reference
                </Button>
              </Box>

              <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 4, border: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.06)', overflow: 'hidden', bgcolor: 'white' }}>
                <Table sx={{ width: '100%', tableLayout: 'auto', '& .MuiTableCell-root': { borderColor: '#f0f0f0', py: 2.5 } }}>
                  <TableHead sx={{ bgcolor: '#f8fafc' }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Ref Number</TableCell>
                      <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Type</TableCell>
                      <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Subject</TableCell>
                      <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Created By</TableCell>
                      <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Status</TableCell>
                      <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {project.references && project.references.map((ref) => (
                      <TableRow 
                        key={ref.id} 
                        hover 
                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', transition: 'background-color 0.2s, transform 0.1s', '&:hover': { bgcolor: '#f8fbff !important' } }}
                      >
                        <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                                <Avatar sx={{ 
                                    bgcolor: '#eff6ff', 
                                    color: '#2563eb', 
                                    fontWeight: '900', 
                                    width: 46, height: 46, 
                                    boxShadow: '0 4px 10px rgba(37,99,235,0.2)'
                                }}>
                                    {ref.ref_number ? ref.ref_number.substring(0,2).toUpperCase() : 'RF'}
                                </Avatar>
                                <Box>
                                    <Typography fontWeight="700" sx={{ color: '#1e293b', fontSize: '0.95rem' }}>{ref.ref_number}</Typography>
                                </Box>
                            </Box>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={ref.type} 
                            size="small" 
                            lineHeight="1"
                            sx={{ 
                                bgcolor: ref.type === 'In' ? '#eff6ff' : ref.type === 'Out' ? '#fff7ed' : '#f0fdf4',
                                color: ref.type === 'In' ? '#1e40af' : ref.type === 'Out' ? '#c2410c' : '#166534',
                                fontWeight: 'bold',
                                borderRadius: '6px', px: 1, height: 26, fontSize: '0.75rem'
                            }} 
                          />
                        </TableCell>
                        <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>{ref.subject}</TableCell>
                        <TableCell sx={{ color: '#64748b', fontWeight: 600, fontSize: '0.85rem' }}>{ref.user}</TableCell>
                        <TableCell>
                            <Chip 
                                label={ref.status} 
                                size="small" 
                                sx={{ bgcolor: '#f1f5f9', color: '#475569', fontWeight: 'bold', borderRadius: '6px', px: 1, height: 26, fontSize: '0.75rem' }} 
                            />
                        </TableCell>
                        <TableCell sx={{ color: '#64748b', fontWeight: 600, fontSize: '0.85rem' }}>{ref.created_at}</TableCell>
                      </TableRow>
                    ))}
                    {(!project.references || project.references.length === 0) && (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                          <Typography sx={{ color: '#94a3b8', fontWeight: 600 }}>No references found for this project.</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </TabPanel>

            {/* AI Reports Tab */}
            <TabPanel value={tabValue} index={7}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>AI Report Generation</Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button 
                    variant="outlined" 
                    startIcon={loadingAiHistory ? <CircularProgress size={20} /> : <HistoryIcon />} 
                    onClick={fetchAiReportHistory}
                    disabled={loadingAiHistory}
                    sx={{ borderRadius: 2, fontWeight: 'bold', textTransform: 'none' }}
                  >
                    Refresh History
                  </Button>
                  <Button 
                    variant="contained" 
                    startIcon={<AutoAwesomeIcon />} 
                    onClick={() => { setSelectedAiReport(''); setOpenAiReportDialog(true); }} 
                    sx={{ 
                      borderRadius: 2, 
                      fontWeight: 'bold', 
                      textTransform: 'none',
                      boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                      background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                    }}
                  >
                    Generate New Report
                  </Button>
                </Box>
              </Box>

              <Typography variant="body2" sx={{ color: '#64748b', mb: 4 }}>
                Upload an Excel file and select a report type to generate AI-powered reports. Previously generated reports are listed below for download.
              </Typography>

              {loadingAiHistory ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                  <CircularProgress />
                </Box>
              ) : aiReportHistory.length === 0 ? (
                <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
                  <AutoAwesomeIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2, opacity: 0.5 }} />
                  <Typography variant="h6" color="#64748b" fontWeight="700" mb={1}>No AI Reports Generated Yet</Typography>
                  <Typography variant="body2" color="#94a3b8" mb={3}>Generate your first AI report by clicking the "Generate New Report" button above.</Typography>
                  <Button 
                    variant="contained" 
                    startIcon={<AutoAwesomeIcon />} 
                    onClick={() => setOpenAiReportDialog(true)} 
                    sx={{ borderRadius: 2, fontWeight: 'bold', textTransform: 'none', background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)' }}
                  >
                    Generate Report
                  </Button>
                </Paper>
              ) : (
                <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 4, border: '1px solid #f1f5f9', overflow: 'hidden' }}>
                  <Table>
                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase' }}>Report Name</TableCell>
                        <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase' }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase' }}>Created</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {aiReportHistory.map((report, idx) => (
                        <TableRow key={idx} hover>
                          <TableCell sx={{ fontWeight: 600, color: '#334155' }}>{report.name || report.filename || `Report #${idx + 1}`}</TableCell>
                          <TableCell>
                            <Chip label={report.type || report.report_type || 'AI Report'} size="small" sx={{ bgcolor: '#eff6ff', color: '#1e40af', fontWeight: 700, borderRadius: 1.5 }} />
                          </TableCell>
                          <TableCell sx={{ color: '#64748b', fontSize: '0.85rem' }}>{report.created_at || report.date || '—'}</TableCell>
                          <TableCell align="right">
                            <Tooltip title="Download Report">
                              <IconButton 
                                onClick={() => {
                                  window.open(`${API_URL}/ai-reports/download/${report.id}`, '_blank');
                                }}
                                sx={{ bgcolor: '#eff6ff', color: '#2563eb', '&:hover': { bgcolor: '#dbeafe' } }}
                              >
                                <DownloadIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </TabPanel>

            {/* Contracts Tab */}
            {canViewContracts && (
            <TabPanel value={tabValue} index={6}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Project Contracts</Typography>
                <Button 
                    variant="contained" 
                    startIcon={<AddIcon />} 
                    onClick={() => {
                      setNewContract({
                        client_id: project.client_id || '',
                        country_id: project.country_id || '',
                        division_id: project.division_id || '',
                        description: '',
                        ddp: '',
                        file: null
                      });
                      setOpenAddContract(true);
                    }} 
                    sx={{ 
                        borderRadius: 2, 
                        fontWeight: 'bold', 
                        textTransform: 'none',
                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                    }}
                >
                  Add Contract
                </Button>
              </Box>

              {contracts.length === 0 ? (
                <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
                    <DescriptionIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                    <Typography variant="h6" color="#64748b" fontWeight="700" mb={1}>No Contracts Found</Typography>
                    <Typography variant="body2" color="#94a3b8" mb={3}>No contracts have been created for this project yet.</Typography>
                    <Button variant="outlined" onClick={handleOpenAddContract} sx={{ borderRadius: 2, fontWeight: 700, borderWidth: 2, '&:hover': { borderWidth: 2 } }}>Add First Contract</Button>
                </Paper>
              ) : (
                <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 4, border: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.06)', overflow: 'hidden', bgcolor: 'white' }}>
                  <Table sx={{ width: '100%', tableLayout: 'auto', '& .MuiTableCell-root': { borderColor: '#f0f0f0', py: 2.5 } }}>
                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>ID</TableCell>
                        <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Client</TableCell>
                        <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Status</TableCell>
                        <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Description</TableCell>
                        <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Location</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {contracts.map(c => (
                        <TableRow 
                          key={c.id} 
                          hover
                          sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', transition: 'background-color 0.2s, transform 0.1s', '&:hover': { bgcolor: '#f8fbff !important' } }}
                          onClick={() => navigate(`/contracts/${c.id}`)}
                        >
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                                <Avatar sx={{ bgcolor: '#eff6ff', color: '#2563eb', fontWeight: '900', width: 46, height: 46, boxShadow: '0 4px 10px rgba(37,99,235,0.2)' }}>
                                    {c.id}
                                </Avatar>
                                <Typography variant="caption" sx={{ fontWeight: '800', color: '#3b82f6', bgcolor: '#eff6ff', px: 1, py: 0.25, borderRadius: 1.5, display: 'inline-block' }}>CT-{c.id}</Typography>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>{c.client_name}</TableCell>
                          <TableCell>
                            <Chip 
                              label={c.status} 
                              size="small" 
                              sx={{ 
                                height: 26, fontSize: '0.75rem', fontWeight: 'bold', borderRadius: '6px', px: 1,
                                bgcolor: c.status === 'Signed' ? '#dcfce7' : c.status === 'Done by Client' ? '#eff6ff' : c.status === 'In Progress' ? '#fff7ed' : '#f1f5f9',
                                color: c.status === 'Signed' ? '#166534' : c.status === 'Done by Client' ? '#1e40af' : c.status === 'In Progress' ? '#c2410c' : '#475569'
                              }} 
                            />
                          </TableCell>
                          <TableCell sx={{ maxWidth: 300, color: '#64748b', fontWeight: 500, fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {c.description}
                          </TableCell>
                          <TableCell>
                            <Typography sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>{c.country} - {c.division}</Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </TabPanel>
            )}

            {/* Financial Tab */}
            <TabPanel value={tabValue} index={8}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {/* Financial Overview Card */}
                <Card elevation={0} sx={{ borderRadius: 4, boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4 }}>
                      <AttachMoneyIcon sx={{ color: '#2563eb' }} />
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Financial Overview</Typography>
                      <Box sx={{ flexGrow: 1 }} />
                      <Chip 
                        label={project.budget ? `${Math.round((project.spent / project.budget) * 100) || 0}% Utilized` : "No Budget"} 
                        size="small" 
                        sx={{ 
                          fontWeight: 800, 
                          borderRadius: 1.5, 
                          bgcolor: project.spent > project.budget ? '#fef2f2' : '#f8fafc',
                          color: project.spent > project.budget ? '#dc2626' : '#64748b',
                          border: `1px solid ${project.spent > project.budget ? '#fca5a5' : '#e2e8f0'}`,
                        }}
                      />
                    </Box>
                    
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#f0f9ff', borderRadius: 3, border: '1px solid #bae6fd' }}>
                          <Typography variant="caption" sx={{ color: '#0ea5e9', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5 }}>TOTAL BUDGET</Typography>
                          <Typography variant="h5" sx={{ fontWeight: 800, color: '#0369a1', mt: 0.5 }}>${project.budget?.toLocaleString()}</Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0' }}>
                          <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5 }}>TOTAL SPENT</Typography>
                          <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', mt: 0.5 }}>${project.spent?.toLocaleString()}</Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#f0fdf4', borderRadius: 3, border: '1px solid #bbf7d0' }}>
                          <Typography variant="caption" sx={{ color: '#16a34a', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5 }}>REMAINING</Typography>
                          <Typography variant="h5" sx={{ fontWeight: 800, color: '#15803d', mt: 0.5 }}>${((project.budget || 0) - (project.spent || 0)).toLocaleString()}</Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#fefce8', borderRadius: 3, border: '1px solid #fef08a' }}>
                          <Typography variant="caption" sx={{ color: '#ca8a04', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5 }}>QUOTE WON</Typography>
                          <Typography variant="h5" sx={{ fontWeight: 800, color: '#a16207', mt: 0.5 }}>${(project.quote_won_value || 0).toLocaleString()}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    
                    <Box sx={{ mt: 3 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b' }}>Budget Utilization</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 800, color: '#0f172a' }}>{project.budget ? Math.round((project.spent / project.budget) * 100) || 0 : 0}%</Typography>
                      </Box>
                      <LinearProgress 
                        variant="determinate" 
                        value={project.budget ? Math.min((project.spent / project.budget) * 100, 100) : 0} 
                        sx={{ 
                          height: 10, 
                          borderRadius: 5, 
                          bgcolor: '#f1f5f9',
                          '& .MuiLinearProgress-bar': { 
                            borderRadius: 5,
                            bgcolor: project.spent > project.budget ? '#ef4444' : '#10b981'
                          } 
                        }} 
                      />
                    </Box>
                  </CardContent>
                </Card>

                {/* Payments Section */}
                <Card elevation={0} sx={{ borderRadius: 4, boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <AttachMoneyIcon sx={{ color: '#2563eb' }} />
                        <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Payments</Typography>
                      </Box>
                      <Button 
                        variant="contained" 
                        startIcon={<AddIcon />} 
                        onClick={handleOpenAddPayment}
                        sx={{ 
                          borderRadius: 2, 
                          fontWeight: 'bold', 
                          textTransform: 'none',
                          boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                          background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
                        }}
                      >
                        Add Payment
                      </Button>
                    </Box>

                    {payments.length === 0 ? (
                      <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
                        <AttachMoneyIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2, opacity: 0.5 }} />
                        <Typography variant="h6" color="#64748b" fontWeight="700" mb={1}>No Payments Recorded</Typography>
                        <Typography variant="body2" color="#94a3b8" mb={3}>Add payments received for this project.</Typography>
                        <Button variant="outlined" onClick={handleOpenAddPayment} sx={{ borderRadius: 2, fontWeight: 700, borderWidth: 2, '&:hover': { borderWidth: 2 } }}>Add First Payment</Button>
                      </Paper>
                    ) : (
                      <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 3, border: '1px solid #f1f5f9', overflow: 'hidden' }}>
                        <Table sx={{ '& .MuiTableCell-root': { borderColor: '#f0f0f0', py: 2 } }}>
                          <TableHead sx={{ bgcolor: '#f8fafc' }}>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem' }}>Amount</TableCell>
                              <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem' }}>Date</TableCell>
                              <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem' }}>Method</TableCell>
                              <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem' }}>Reference</TableCell>
                              <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem' }}>Status</TableCell>
                              <TableCell sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem' }}>Notes</TableCell>
                              <TableCell align="right" sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem' }}>Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {payments.map((pym) => (
                              <TableRow key={pym.id} hover>
                                <TableCell sx={{ fontWeight: 700, color: '#0f172a' }}>${pym.amount?.toLocaleString()}</TableCell>
                                <TableCell sx={{ color: '#475569' }}>{pym.payment_date || '—'}</TableCell>
                                <TableCell>
                                  <Chip label={pym.payment_method || 'N/A'} size="small" sx={{ bgcolor: '#f1f5f9', color: '#334155', fontWeight: 600, borderRadius: 1.5 }} />
                                </TableCell>
                                <TableCell sx={{ color: '#475569', fontFamily: 'monospace' }}>{pym.reference_number || '—'}</TableCell>
                                <TableCell>
                                  <Chip 
                                    label={pym.status} 
                                    size="small" 
                                    sx={{ 
                                      fontWeight: 700, borderRadius: 1.5,
                                      bgcolor: pym.status === 'Received' || pym.status === 'Cleared' ? '#dcfce7' : pym.status === 'Pending' ? '#fff7ed' : '#f1f5f9',
                                      color: pym.status === 'Received' || pym.status === 'Cleared' ? '#166534' : pym.status === 'Pending' ? '#c2410c' : '#475569'
                                    }} 
                                  />
                                </TableCell>
                                <TableCell sx={{ color: '#64748b', maxWidth: 150, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{pym.notes || '—'}</TableCell>
                                <TableCell align="right">
                                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
                                    <Tooltip title="Edit">
                                      <IconButton size="small" onClick={() => handleEditPayment(pym)} sx={{ color: '#f59e0b', bgcolor: '#fffbeb', '&:hover': { bgcolor: '#fef3c7' } }}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                      <IconButton size="small" onClick={() => handleDeletePayment(pym.id)} sx={{ color: '#ef4444', bgcolor: '#fef2f2', '&:hover': { bgcolor: '#fee2e2' } }}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </CardContent>
                </Card>
              </Box>
            </TabPanel>
          </Paper>
        </Grid>
      </Grid>

      {/* Dialogs */}
      <Dialog 
        open={openReportDialog} 
        onClose={() => setOpenReportDialog(false)}
        PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
            Add New Report
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
          <TextField
            autoFocus 
            margin="dense" 
            label="Report Name" 
            fullWidth
            value={newReportName} 
            onChange={(e) => setNewReportName(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button 
            onClick={() => setOpenReportDialog(false)} 
            variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleAddReport} 
            variant="contained" 
            disabled={createReportLoading}
            sx={{ 
                borderRadius: 2, 
                fontWeight: 'bold', 
                minWidth: 100,
                boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
            }}
          >
            {createReportLoading ? <CircularProgress size={24} color="inherit" /> : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAssignDialog} onClose={() => setOpenAssignDialog(false)} PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}>
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
            Assign Team Member
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
          <Autocomplete
            fullWidth
            options={allUsers}
            getOptionLabel={(option) => `${option.full_name} (${option.role})`}
            filterOptions={(options, { inputValue }) => {
                return options.filter(option =>
                    option.username.toLowerCase().includes(inputValue.toLowerCase()) ||
                    (option.full_name && option.full_name.toLowerCase().includes(inputValue.toLowerCase()))
                );
            }}
            value={allUsers.find(u => u.id === assignUser) || null}
            onChange={(event, newValue) => {
                setAssignUser(newValue ? newValue.id : '');
            }}
            renderInput={(params) => (
                <TextField 
                    {...params} 
                    label="Select User" 
                    placeholder="Search user..." 
                    sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />
            )}
            sx={{ '& .MuiAutocomplete-paper': { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
          />
          <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}>
            <InputLabel>Project Role</InputLabel>
            <Select value={assignRole} onChange={(e) => setAssignRole(e.target.value)} label="Project Role">
              <MenuItem value="Manager">Manager</MenuItem>
              <MenuItem value="Lead">Lead</MenuItem>
              <MenuItem value="Member">Member</MenuItem>
              <MenuItem value="Viewer">Viewer</MenuItem>
              <MenuItem value="Engineer">Engineer</MenuItem>
              <MenuItem value="Tester">Tester</MenuItem>
              <MenuItem value="Driller">Driller</MenuItem>
              <MenuItem value="Reporter">Reporter</MenuItem>
              <MenuItem value="Accountant">Accountant</MenuItem>
              <MenuItem value="Driver">Driver</MenuItem>
              <MenuItem value="Technician">Technician</MenuItem>
              <MenuItem value="Surveyor">Surveyor</MenuItem>
              <MenuItem value="Supervisor">Supervisor</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button 
            onClick={() => setOpenAssignDialog(false)} 
            variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleAssignUser} 
            variant="contained" 
            disabled={assignLoading}
            sx={{ 
                borderRadius: 2, 
                fontWeight: 'bold', 
                minWidth: 100,
                boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
            }}
          >
            {assignLoading ? <CircularProgress size={24} color="inherit" /> : 'Assign'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog 
        open={openMilestoneDialog} 
        onClose={() => setOpenMilestoneDialog(false)}
        PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
            Add Milestone
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
          <TextField
            autoFocus 
            margin="dense" 
            label="Milestone Name" 
            fullWidth
            value={newMilestoneName} 
            onChange={(e) => setNewMilestoneName(e.target.value)}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense" 
            label="Due Date" 
            type="date" 
            fullWidth 
            InputLabelProps={{ shrink: true }}
            value={newMilestoneDate} 
            onChange={(e) => setNewMilestoneDate(e.target.value)}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense" 
            label="Description" 
            fullWidth 
            multiline 
            rows={3}
            value={newMilestoneDesc} 
            onChange={(e) => setNewMilestoneDesc(e.target.value)}
            sx={{ mb: 1, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button 
            onClick={() => setOpenMilestoneDialog(false)} 
            variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleAddMilestone} 
            variant="contained"
            sx={{ 
                borderRadius: 2, 
                fontWeight: 'bold', 
                minWidth: 100,
                boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
            }}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
      
      <Dialog 
        open={openReferenceDialog} 
        onClose={() => setOpenReferenceDialog(false)}
        PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
            Add Reference
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
          <FormControl fullWidth margin="dense" sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}>
            <InputLabel>Type</InputLabel>
            <Select label="Type" value={newReference.type} onChange={(e) => setNewReference({...newReference, type: e.target.value})}>
              <MenuItem value="In">In</MenuItem>
              <MenuItem value="Out">Out</MenuItem>
              <MenuItem value="Certification">Certification</MenuItem>
            </Select>
          </FormControl>
          <TextField
            margin="dense" label="Subject" fullWidth
            value={newReference.subject} onChange={(e) => setNewReference({...newReference, subject: e.target.value})}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense" label="Recipient / To" fullWidth
            value={newReference.recipient_to} onChange={(e) => setNewReference({...newReference, recipient_to: e.target.value})}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense" label="Address" fullWidth
            value={newReference.address} onChange={(e) => setNewReference({...newReference, address: e.target.value})}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense" label="Description" fullWidth multiline rows={3}
            value={newReference.description} onChange={(e) => setNewReference({...newReference, description: e.target.value})}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button 
            onClick={() => setOpenReferenceDialog(false)} 
            variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleCreateReference} 
            variant="contained"
            disabled={createReferenceLoading}
            sx={{ 
                borderRadius: 2, 
                fontWeight: 'bold', 
                minWidth: 100,
                boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
            }}
          >
            {createReferenceLoading ? <CircularProgress size={24} color="inherit" /> : 'Create'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Member Hours Dialog */}
      <Dialog open={openMemberDialog} onClose={() => setOpenMemberDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
            {selectedMember?.name} - Work Log
        </DialogTitle>
        <DialogContent>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Time</TableCell>
                        <TableCell>Duration (Hrs)</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Description</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {memberHours.map((log) => (
                        <TableRow key={log.id}>
                            <TableCell>{log.date}</TableCell>
                            <TableCell>{log.start_time} - {log.end_time}</TableCell>
                            <TableCell>{log.duration}</TableCell>
                            <TableCell>{log.type_of_work}</TableCell>
                            <TableCell>{log.description}</TableCell>
                        </TableRow>
                    ))}
                    {memberHours.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={5} align="center">No work logs found.</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpenMemberDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={qrDialog.open} onClose={() => setQrDialog({ ...qrDialog, open: false })} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ textAlign: 'center' }}>{qrDialog.title}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <img 
              src={qrDialog.url} 
              alt="QR Code" 
              style={{ maxWidth: '100%', height: 'auto', borderRadius: 8, border: '1px solid #eee' }} 
              onError={(e) => {e.target.onerror = null; e.target.src="https://via.placeholder.com/150?text=No+QR"}}
            />
          </Box>
          <Typography variant="caption" display="block" align="center" color="textSecondary">
            Scan to view details
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
          <Button onClick={() => setQrDialog({ ...qrDialog, open: false })} variant="outlined">Close</Button>
        </DialogActions>
      </Dialog>

      {/* Edit SubReport Dialog */}
      <Dialog open={editSubDialog.open} onClose={() => setEditSubDialog({ open: false, sub: null, submittedAt: '' })} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 800 }}>Edit Submitted On</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            type="date"
            label="Submitted On"
            InputLabelProps={{ shrink: true }}
            value={editSubDialog.submittedAt}
            onChange={(e) => setEditSubDialog(prev => ({ ...prev, submittedAt: e.target.value }))}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button onClick={() => setEditSubDialog({ open: false, sub: null, submittedAt: '' })} variant="outlined">Cancel</Button>
          <Button
            onClick={handleSaveSubEdit}
            variant="contained"
            disabled={savingSubEdit}
            startIcon={savingSubEdit ? <CircularProgress size={18} color="inherit" /> : <SaveIcon />}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Milestone Dialog */}
      <Dialog 
        open={openEditMilestoneDialog} 
        onClose={() => setOpenEditMilestoneDialog(false)}
        PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
            Edit Milestone
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
          <TextField
            autoFocus 
            margin="dense" 
            label="Milestone Name" 
            fullWidth
            value={editMilestoneName} 
            onChange={(e) => setEditMilestoneName(e.target.value)}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense" 
            label="Due Date" 
            type="date" 
            fullWidth 
            InputLabelProps={{ shrink: true }}
            value={editMilestoneDate} 
            onChange={(e) => setEditMilestoneDate(e.target.value)}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense" 
            label="Description" 
            fullWidth 
            multiline 
            rows={3}
            value={editMilestoneDesc} 
            onChange={(e) => setEditMilestoneDesc(e.target.value)}
            sx={{ mb: 1, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button 
            onClick={() => setOpenEditMilestoneDialog(false)} 
            variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSaveEditMilestone} 
            variant="contained"
            sx={{ 
                borderRadius: 2, 
                fontWeight: 'bold', 
                minWidth: 100,
                boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Contract Dialog */}
      <Dialog 
        open={openAddContract} 
        onClose={() => setOpenAddContract(false)} 
        maxWidth="md" 
        fullWidth 
        PaperProps={{ sx: { borderRadius: 4, overflow: 'hidden' } }}
      >
        <DialogTitle sx={{ bgcolor: '#1e3c72', color: 'white', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Add New Contract
            <IconButton size="small" onClick={() => setOpenAddContract(false)} sx={{ color: 'white' }}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: { xs: 2, sm: 4 }, bgcolor: '#f8fafc' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
                <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ mb: 3, fontWeight: 800, color: '#64748b', textTransform: 'uppercase' }}>Basic Information</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={clientsForContract}
                                getOptionLabel={(option) => option.name || ""}
                                value={clientsForContract.find(c => String(c.id) === String(newContract.client_id)) || null}
                                onChange={(event, newValue) => {
                                    setNewContract({...newContract, client_id: newValue ? newValue.id : ''});
                                }}
                                renderInput={(params) => <TextField {...params} label="Client" fullWidth variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Autocomplete
                                options={allProjects}
                                getOptionLabel={(option) => option.name || ""}
                                value={allProjects.find(p => String(p.id) === String(id)) || null}
                                disabled
                                renderInput={(params) => <TextField {...params} label="Project" fullWidth variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField 
                                fullWidth 
                                multiline 
                                rows={3} 
                                label="Description" 
                                value={newContract.description} 
                                onChange={e => setNewContract({...newContract, description: e.target.value})} 
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </Paper>
                <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ mb: 3, fontWeight: 800, color: '#64748b', textTransform: 'uppercase' }}>Classification & Details</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Country</InputLabel>
                                <Select 
                                    value={newContract.country_id} 
                                    label="Country" 
                                    onChange={e => setNewContract({...newContract, country_id: e.target.value})}
                                >
                                    {countries.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Division</InputLabel>
                                <Select 
                                    value={newContract.division_id} 
                                    label="Division" 
                                    onChange={e => setNewContract({...newContract, division_id: e.target.value})}
                                >
                                    {divisions.map(d => <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Document Type</InputLabel>
                                <Select 
                                    value={newContract.document_type} 
                                    label="Document Type" 
                                    onChange={e => setNewContract({...newContract, document_type: e.target.value})}
                                >
                                    <MenuItem value="Subcontract">Subcontract</MenuItem>
                                    <MenuItem value="Tender Subcontract">Tender Subcontract</MenuItem>
                                    <MenuItem value="NDA">NDA</MenuItem>
                                    <MenuItem value="Purchase Order (PO)">Purchase Order (PO)</MenuItem>
                                    <MenuItem value="Change Order Confirmation (COC)">Change Order Confirmation (COC)</MenuItem>
                                    <MenuItem value="Letter of Award (LOA)">Letter of Award (LOA)</MenuItem>
                                    <MenuItem value="Letter of Intent (LOI)">Letter of Intent (LOI)</MenuItem>
                                    <MenuItem value="Addendum">Addendum</MenuItem>
                                    <MenuItem value="Other Documents">Other Documents</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>DDP Location</InputLabel>
                                <Select 
                                    value={newContract.ddp} 
                                    label="DDP Location" 
                                    onChange={e => setNewContract({...newContract, ddp: e.target.value})}
                                >
                                    <MenuItem value="Lebanon">Lebanon</MenuItem>
                                    <MenuItem value="KSA">KSA</MenuItem>
                                    <MenuItem value="Qatar">Qatar</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Button variant="outlined" component="label" fullWidth sx={{ height: '56px', borderRadius: '4px' }}>
                                Upload Contract PDF
                                <input 
                                    type="file" 
                                    hidden 
                                    accept="application/pdf" 
                                    onChange={e => setNewContract({...newContract, file: e.target.files[0]})} 
                                />
                            </Button>
                            {newContract.file && <Typography variant="caption" sx={{ mt: 1, display: 'block', color: 'text.secondary' }}>{newContract.file.name}</Typography>}
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 2, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
            <Button onClick={() => setOpenAddContract(false)} sx={{ color: '#64748b', fontWeight: 'bold' }}>Cancel</Button>
            <Button 
                onClick={handleCreateContract} 
                variant="contained" 
                disabled={createContractLoading}
                sx={{ 
                    borderRadius: 2, 
                    fontWeight: 'bold', 
                    px: 3, 
                    py: 1,
                    background: 'linear-gradient(45deg, #1e3c72 0%, #2a5298 100%)',
                    boxShadow: '0 4px 12px rgba(30,60,114,0.3)'
                }}
            >
              {createContractLoading ? 'Creating...' : 'Create Contract'}
            </Button>
        </DialogActions>
      </Dialog>

      {/* Hidden file input for subreport uploads */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept="application/pdf"
        onChange={handleSubReportFileChange}
      />

      {/* GFR Generate Dialog */}
      <Dialog 
        open={openGfrDialog} 
        onClose={() => { setOpenGfrDialog(false); resetGfrForm(); }}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 4, overflow: 'hidden' } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1 }}>
          <AutoAwesomeIcon sx={{ color: '#1976d2' }} />
          Generate GFR (Geo) Report
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, overflow: 'visible' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#475569' }}>Country:</Typography>
                <Box sx={{ display: 'flex', bgcolor: '#f1f5f9', borderRadius: 2, p: 0.5 }}>
                  {['KSA', 'Qatar'].map(c => (
                    <Button key={c} size="small"
                      sx={{ px: 2, py: 0.5, borderRadius: 1.5, fontWeight: 700, fontSize: '0.75rem',
                        bgcolor: gfrCountryOrigin === c ? '#1976d2' : 'transparent',
                        color: gfrCountryOrigin === c ? 'white' : '#64748b' }}
                      onClick={() => setGfrCountryOrigin(c)}
                    >{c}</Button>
                  ))}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('project_location_image', 'Project Location Image', 'image/*', true)}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('bore_hole_image', 'Bore Hole Image', 'image/*', true)}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('trial_pit_image', 'Trial Pit Image', 'image/*', true)}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('geological_map', 'Geological Map Image', 'image/*', gfrCountryOrigin === 'KSA')}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('gint_file', 'Gint Sheet', '.xlsx,.xls,.csv', true)}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('groundwater_file', 'Ground Water Sheet', '.xlsx,.xls,.csv')}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('falling_head_file', 'Falling Head Sheet', '.xlsx,.xls,.csv')}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('n60_file', 'N60 Sheet', '.xlsx,.xls,.csv')}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('pmt_file', 'PMT Sheet', '.xlsx,.xls,.csv')}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('soakaway_file', 'Soakaway Sheet', '.xlsx,.xls,.csv')}</Grid>
            <Grid item xs={12} sm={6}>{renderGfrFileDropzone('lab_file', 'Lab Sheet', '.xlsx,.xls,.csv')}</Grid>
            <Grid item xs={12}>{renderGfrFileDropzone('packer_files', 'Packer Sheets (Multiple)', '.xlsx,.xls,.csv')}</Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={3} label="Site Description" value={gfrSiteDescription}
                onChange={e => setGfrSiteDescription(e.target.value)}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
            </Grid>
            {gfrCountryOrigin === 'KSA' && (
              <Grid item xs={12}>
                <TextField fullWidth multiline rows={3} label="Regional Geology" value={gfrRegionalGeology}
                  onChange={e => setGfrRegionalGeology(e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button onClick={() => { setOpenGfrDialog(false); resetGfrForm(); }} variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold' }}>Cancel</Button>
          <Button onClick={handleGenerateGfr} variant="contained" disabled={generatingGfr}
            sx={{ borderRadius: 2, fontWeight: 'bold', minWidth: 140,
              boxShadow: '0 4px 14px rgba(25,118,210,0.3)', background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
              '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' } }}
            startIcon={generatingGfr ? <CircularProgress size={20} color="inherit" /> : <AutoAwesomeIcon />}>
            {generatingGfr ? 'Generating...' : 'Generate GFR Report'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* AI Report Generate Dialog */}
      <Dialog 
        open={openAiReportDialog} 
        onClose={() => { setOpenAiReportDialog(false); setAiReportFiles([]); setSelectedAiReport(''); }}
        PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b', display: 'flex', alignItems: 'center', gap: 1 }}>
          <AutoAwesomeIcon sx={{ color: '#1976d2' }} />
          Generate AI Report
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
          <FormControl fullWidth margin="dense" sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}>
            <InputLabel>Report Type</InputLabel>
            <Select 
              label="Report Type" 
              value={selectedAiReport} 
              onChange={(e) => {
                const val = e.target.value;
                if (val === 'gfr') {
                  setOpenAiReportDialog(false);
                  setTimeout(() => setOpenGfrDialog(true), 100);
                } else {
                  setSelectedAiReport(val);
                }
              }}
            >
              {aiReportTypes.map(rt => (
                <MenuItem key={rt.value} value={rt.value}>{rt.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#475569', mb: 1.5 }}>
              Upload Excel File
            </Typography>
            <Paper 
              elevation={0}
              sx={{ 
                p: 4, 
                textAlign: 'center', 
                bgcolor: '#f8fafc', 
                borderRadius: 3, 
                border: '2px dashed #cbd5e1', 
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': { borderColor: '#1976d2', bgcolor: '#eff6ff' }
              }}
              onClick={() => aiFileInputRef.current && aiFileInputRef.current.click()}
            >
              {aiReportFiles.length > 0 ? (
                <Box>
                  <InsertDriveFileIcon sx={{ fontSize: 48, color: '#1976d2', mb: 1 }} />
                  <Typography variant="body1" sx={{ fontWeight: 700, color: '#1e293b' }}>
                    {aiReportFiles.length} file(s) selected
                  </Typography>
                  {aiReportFiles.map((f, i) => (
                    <Typography key={i} variant="caption" color="#64748b" display="block">
                      {f.name} ({(f.size / 1024 / 1024).toFixed(2)} MB)
                    </Typography>
                  ))}
                </Box>
              ) : (
                <Box>
                  <CloudUploadIcon sx={{ fontSize: 48, color: '#94a3b8', mb: 1, opacity: 0.7 }} />
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#64748b' }}>
                    Click to select an Excel file
                  </Typography>
                  <Typography variant="caption" color="#94a3b8">
                    .xlsx, .xls, .xlsm supported
                  </Typography>
                </Box>
              )}
            </Paper>
            <input
              type="file"
              ref={aiFileInputRef}
              style={{ display: 'none' }}
              accept=".xlsx,.xls,.xlsm"
              multiple
              onChange={handleAiFileSelect}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button 
            onClick={() => { setOpenAiReportDialog(false); setAiReportFiles([]); setSelectedAiReport(''); }}
            variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleGenerateAiReport} 
            variant="contained"
            disabled={generatingAiReport || !selectedAiReport || aiReportFiles.length === 0}
            sx={{ 
              borderRadius: 2, 
              fontWeight: 'bold', 
              minWidth: 140,
              boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
              background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
              '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
            }}
            startIcon={generatingAiReport ? <CircularProgress size={20} color="inherit" /> : <AutoAwesomeIcon />}
          >
            {generatingAiReport ? 'Generating...' : 'Generate Report'}
          </Button>
        </DialogActions>
      </Dialog>


      {/* Payment Add/Edit Dialog */}
      <Dialog 
        open={openPaymentDialog} 
        onClose={() => setOpenPaymentDialog(false)}
        PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}
      >
        <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
          {editingPayment ? 'Edit Payment' : 'Add Payment'}
        </DialogTitle>
        <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
          <TextField
            autoFocus
            margin="dense"
            label="Amount ($)"
            type="number"
            fullWidth
            value={paymentForm.amount}
            onChange={(e) => setPaymentForm({...paymentForm, amount: e.target.value})}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            margin="dense"
            label="Payment Date"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={paymentForm.payment_date}
            onChange={(e) => setPaymentForm({...paymentForm, payment_date: e.target.value})}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <FormControl fullWidth margin="dense" sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}>
            <InputLabel>Payment Method</InputLabel>
            <Select 
              label="Payment Method" 
              value={paymentForm.payment_method} 
              onChange={(e) => setPaymentForm({...paymentForm, payment_method: e.target.value})}
            >
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Wire Transfer">Wire Transfer</MenuItem>
              <MenuItem value="Cheque">Cheque</MenuItem>
              <MenuItem value="Credit Card">Credit Card</MenuItem>
              <MenuItem value="Bank Deposit">Bank Deposit</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>
          <TextField
            margin="dense"
            label="Reference Number"
            fullWidth
            value={paymentForm.reference_number}
            onChange={(e) => setPaymentForm({...paymentForm, reference_number: e.target.value})}
            placeholder="Transaction ref / Cheque no."
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <FormControl fullWidth margin="dense" sx={{ mb: 2, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}>
            <InputLabel>Status</InputLabel>
            <Select 
              label="Status" 
              value={paymentForm.status} 
              onChange={(e) => setPaymentForm({...paymentForm, status: e.target.value})}
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Received">Received</MenuItem>
              <MenuItem value="Cleared">Cleared</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
          <TextField
            margin="dense"
            label="Notes"
            fullWidth
            multiline
            rows={2}
            value={paymentForm.notes}
            onChange={(e) => setPaymentForm({...paymentForm, notes: e.target.value})}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
          <Button 
            onClick={() => setOpenPaymentDialog(false)} 
            variant="outlined" 
            sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSavePayment} 
            variant="contained"
            disabled={savingPayment}
            sx={{ 
              borderRadius: 2, 
              fontWeight: 'bold', 
              minWidth: 100,
              boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
              background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
              '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)' }
            }}
          >
            {savingPayment ? <CircularProgress size={24} color="inherit" /> : (editingPayment ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}

export default ProjectDetails;
